import React from 'react';
import PropTypes, { number } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { notification } from 'antd';
import TextField from '@material-ui/core/TextField';

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";

import L from 'leaflet';
import 'leaflet-draw';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import SvgIcon from '@material-ui/core/SvgIcon';
import tools from '../../components/util/tools';
import Calls from '../../components/util/calls';
import Slider from '../../components/Slider/slider';
import geo from '../../components/util/geo';
import pinWaypoint from './../../assets/images/marker/waypoint/pin.png';

import { useParams } from "react-router";

import Backd from '../../components/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import saveAs from 'file-saver';

import Img_mark from './../../components/image/img';
import img from './../point/img';

import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import MaskedInput from 'react-text-mask';

import windArrowImage from '../../assets/images/marker/waypoint/marker-icon.png';

import SpeedIcon from '@material-ui/icons/Speed';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DescriptionIcon from '@material-ui/icons/Description';

import DeltaTHeat from '../../components/heat_graph/deltaTGraph';

import thermalInversionExample from '../../assets/images/thermalInversionExample.png';
import normalFlowExample from '../../assets/images/normalFlowExample.png';

import { AddToPhotosOutlined } from '@material-ui/icons';

import Units from '../../components/util/units';
class marks {
  constructor() {
    this.id = '';
    this.guid = '';
    this.name = '';
    this.icon = '';
    this.alt = '';
    this.lat = '';
    this.lng = '';
    this.r = '';
    this.type = '';
  }
}

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
  table: {
    minWidth: 650,
  },
  customWidthTooltip: {
    maxWidth: 500,
  },
  windDirectionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
  },
  circle: {
    position: 'relative',
    width: '3rem',
    height: '3rem',
    borderRadius: '50%',
    border: '1px solid white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.5rem',
  },
  windDirection: {
    position: 'absolute',
    fontSize: '0.6rem',
    color: 'white',
  },
  north: {
    top: '-2px',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  south: {
    bottom: '-2px',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  east: {
    right: '2px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  west: {
    left: '2px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  windDirectionArrow: {
    position: 'absolute',
    top: '32%',
    left: '36%',
    transform: 'translate(-50%, -50%) rotate(180deg)',
    transition: 'transform 0.3s ease-in-out',
    width: '1rem',
    height: '1.25rem',
  },
  climateTable: {
    width: '100%',
    minWidth: 0,
    tableLayout: 'fixed',
  },
  zoomButtonJobReport: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: '.55rem',
    width: '100%',
  },
  popUpButtonJobReport: {
    marginRight: '0 !important',
    minWidth: '2.4rem',
    paddingLeft: '.75rem !important',
    paddingRight: '.75rem !important',
  },
});

class Edit extends React.Component {
  base_state = {
    markers: [],
    job_guid_b: '',
    job_guid: '',

    title: '',
    title_sk: '',
    aeronavePrefixO: '',
    aeronavePrefixT: '',
    name: '',
    customerNameO: '',
    customerNameT: '',
    descricao: '',
    cost: 0,
    difficulty: -1,

    area_est: 0,
    area_exe: 0,
    area_per: 0,

    dias_est: 0,
    dias_exe: 0,

    vVoo_est: 0,
    vVoo_exe: 0,
    vVooO_per: 0,
    vVooR_per: 0,

    vC_est: 0,
    vC_exe: 0,
    vC_per: 0,

    vVooHA_est: 0,
    vVooHA_exe: 0,
    vVooHA_per: 0,

    vProf_est: 0,
    vProf_exe: 0,
    vProf_per: 0,

    vImp_est: 0,
    vImp_exe: 0,
    vImp_per: 0,

    cVoo_est: 0,
    cVoo_exe: 0,
    cVoo_per: 0,

    cVooHA_est: 0,
    cVooHA_exe: 0,
    cVooHA_per: 0,

    tVoo_est: 0,
    tVoo_exe: 0,
    tVoo_per: 0,

    tSolo_est: 0,
    tSolo_exe: 0,
    tSolo_per: 0,
    tSolo_valor: 0,

    tTotal_est: 0,
    tTotal_exe: 0,
    tTotal_per: 0,
    tTotal_valor: 0,

    tTran_est: 0,
    tTran_exe: 0,
    tTran_per: 0,
    tTran_valor: 0,

    tApl_est: 0,
    tApl_exe: 0,
    tApl_per: 0,
    tApl_valor: 0,

    tLoop_est: 0,
    tLoop_exe: 0,
    tLoop_per: 0,
    tLoop_valor: 0,

    totalApl_est: 0,
    totalApl_exe: 0,
    totalApl_per: 0,

    velLoop_est: 0,
    velLoop_exe: 0,

    velApl_est: 0,
    velApl_exe: 0,

    velTrans_est: 0,
    velTrans_exe: 0,

    dLoop_est: 0,
    dLoop_exe: 0,

    qtdFuel_est: 0,
    qtdFuel_exe: 0,
    qtdFuel_per: 0,

    rend_est: 0,
    rend_exe: 0,
    rend_per: 0,

    lhora_est: 0,
    lhora_exe: 0,

    ruler_a: false,
    stack: false,
    stack_value: [1, 1, 1, 1],
    progress: false,
    progressValue: 0,
    tab: '0',

    base: [],

    itensTask: [],
    task: 0,
    id: 0,
    id_report: '',
    guid: '',
    openTask: false,
    clear: false,
    downloadRelButton: false,
    addKm: false,
    valor: 0,
    time: 0,
    new: { msg: this.props.res.NOVA_AVALIACAO_CONFIRM, func: this.clear },

    showPerc: false,
    percSize: 100,

    checkResumo: false,
    checkResumoDetalhado: false,
    checkResumoTitulo: true,
    checkResumoCliente: true,
    checkResumoPropriedade: true,
    checkResumoArea: true,
    checkResumoFaixa: true,
    checkResumoVazao: true,
    checkResumoInicio: true,
    checkResumoFim: true,
    checkResumoAeronave: true,
    checkResumoPiloto: true,
    checkResumoTalhoes: true,
    checkResumoLatLng: true,
    checkResumoAlturaCultura: true,
    checkVazao: true,
    checkVolume: true,
    checkOnOff: true,
    checkRumo: true,
    checkAltura: true,
    checkCliente: true,
    checkAeronave: true,
    checkClima: true,
    checkTrajetoria: true,
    checkPoligono: true,
    checkPoligonoLimpo: false,
    checkXcl: true,
    checkVelocidade: true,
    checkFaixa: true,
    checkEstenderTiro: false,
    showEstenderTiro: false,
    checkMapa: true,
    checkCoordenadas: true,
    fileFormat: 'kmz',

    openModal: false,
    next: "",

    arrFuel: [],

    nomePiloto: "",
    prefixoAeronave: "",
    aircraftbrands: [],
    aircraftmodels: [],
    id_aircraftbrand: '',
    id_aircraftmodel: '',
    alturaCultura: "",
    ordemServico: '',
    observacoes: '',

    windSpeedFirst: '',
    windSpeedLast: '',
    windHeadingFirst: '',
    windHeadingLast: '',
    temperatureFirst: '',
    temperatureLast: '',
    airRHFirst: '',
    airRHLast: '',
    weatherData: [],
    windSpeedUnit: Units.getSpeedUnit(this.props.res),
    stations: [],
    editingGuid: null,
    properties: [],
    selectedProperty: "",
    isCustomProperty: false,
    customPropertyName: '',
    titulo: '',
    cliente: '',
    areaTotalAplicada: '',
    inicioAplicacao: '',
    fimAplicacao: '',
    talhoes: [],
    poligonos: [],
    coordMode: 'dms',
  };
  state = JSON.parse(JSON.stringify(this.base_state));

  waypointMarker = null;
  waypointIcon = null;
  mapIsDragging = false;

  tabItens = [
    { label: this.props.res.INFORMACAO, value: '0' },
    { label: 'asdasdasd', value: '1' },
  ];

  dificult = [
    0,
    10,
    20,
    30,
    40,
    50,
    60,
  ];

  ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };

  dataEstJob = null;
  dataFullJob = null;

  featureGroupL = null;
  featureGroupP = null;
  featureGroupPoly = null;
  featureGroupPM = null;

  area = 0;
  polyNames = {};

  componentDidMount() {
    this.icon = Img_mark;
    this.boot();
    this.loadAircraftBrands();

    const savedUnit = localStorage.getItem('windSpeedUnit') || Units.getSpeedUnit(this.props.res);
    this.getProfileAuto()

    this.setState({
      windSpeedUnit: savedUnit
    });

    this.listStations();
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  };

  boot = () => {
    this.mymap = L.map('mapid', { zoomControl: false, attributionControl: false, maxZoom: 20 }).setView(Config.place, 14);

    if (this.mymap.doubleClickZoom) {
      this.mymap.doubleClickZoom.disable();
    }

    let tileConfig = Object.assign({}, Config.tile_google_config, { maxZoom: 20 });
    L.tileLayer(Config.tile_google, tileConfig).addTo(this.mymap);

    this.featureGroupL = L.featureGroup();
    this.featureGroupL.addTo(this.mymap);
    this.featureGroupP = L.featureGroup();
    this.featureGroupP.addTo(this.mymap);
    this.featureGroupPoly = L.featureGroup();
    this.featureGroupPoly.addTo(this.mymap);

    this.featureGroupPM = L.featureGroup();
    this.featureGroupPM.addTo(this.mymap);

    new L.Control.Draw({
      draw: {
        polyline: false,
        polygon: false,
        circle: false,
        rectangle: false,
        marker: false,
        circlemarker: false
      },
      edit: false
    }).addTo(this.mymap);

    this.mymap.on('click', () => {
      this.handleClickAplMap();

      if (this.closeWaypointPopup) {
        this.closeWaypointPopup();
      }
    });

    this.mymap.on('dragstart', () => {
      this.mapIsDragging = true;
    });

    this.mymap.on('dragend', () => {
      setTimeout(() => {
        this.mapIsDragging = false;
      }, 0);
    });

    this.mymap.on('movestart', () => {
      this.mapIsDragging = true;
    });

    this.mymap.on('moveend', () => {
      setTimeout(() => {
        this.mapIsDragging = false;
      }, 0);

      this.checkMarkers();
    });

    this.mymap.on('dblclick', (e) => {
      if (!e || !e.latlng) return;
      if (this.mapIsDragging) return;
      if (this.state && this.state.ruler_a) return;

      if (!this.waypointMarker) {
        this.createWaypointMarker(e.latlng);
      } else {
        this.moveWaypointMarker(e.latlng);
      }
    });

    this.mymap.on('draw:drawvertex', e => {
      if (this.drawCreateToolbar.type === 'polyline') {
        let layerIds = Object.keys(e.layers._layers);
        if (layerIds.length > 1) {
          let v2 = e.layers._layers[layerIds[1]];
          this.ruler_p.second.lat = v2._latlng.lat;
          this.ruler_p.second.lng = v2._latlng.lng;
          requestAnimationFrame(() => this.completeRuler());
        } else if (layerIds.length === 1) {
          let v1 = e.layers._layers[layerIds[0]];
          this.ruler_p.first.lat = v1._latlng.lat;
          this.ruler_p.first.lng = v1._latlng.lng;
        }
      }
    });

    L.drawLocal.draw.handlers.polyline.tooltip.start = '';
    L.drawLocal.draw.handlers.polyline.tooltip.cont = '';

    this.loadTask(false);
    if (this.props.guid) {
      localStorage.setItem('c_report_guid', this.props.guid);
      this.checkJob();
    } else if (localStorage.getItem('c_report_guid')) {
      //this.setState({ guid: localStorage.getItem('c_report_guid') });
    }

    this.mymap.on('zoomend', () => {
      this.checkMarkers();
    });

    this.list_markers();

  };

  checkJob = () => {
    let guid = this.state.job_guid ? this.state.job_guid : this.state.job_guid_b ? this.state.job_guid_b : this.props.guid;
    let apiUrl = Config.server + '/job_check/importzjob/' + guid;
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({});
          if (result.task && result.task.id) {
            this.setState({ task: result.task.id });
            this.checkTask(result.task.id, false);
          } else {
            this.setState({ progress: false });
          }
          if (result.id_job) {
            this.setState({ id: result.id_job });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else if (error.status === 400) {
            error.json().then(
              (errCode) => {
                notification.open({
                  message: this.props.res[errCode.code],
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              });
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  list_markers = () => {
    const apiUrl = Config.server + '/point/0';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result.length > 0) {
            let m = [];
            for (let i = 0; i < result.length; i++) {
              const element = result[i];

              let tempMark = new marks();
              tempMark.id = element.id;
              tempMark.guid = element.guid;
              tempMark.name = element.name;
              tempMark.lat = element.lat;
              tempMark.lng = element.lng;
              tempMark.alt = element.height;
              tempMark.r = element.radios;
              tempMark.desc = element.icon;
              tempMark.type = element.type;
              for (let j = 0; j < img.length; j++) {
                if (img[j].desc.includes(element.icon)) {
                  tempMark.img = img[j].img;
                  break;
                }
              }
              if (tempMark.type === 'P' || tempMark.type === 'H' || tempMark.img) {
                m.push(tempMark)
                this.drawMarker(tempMark);
              }
              // m.push(tempMark)
              //this.drawMarker(tempMark);
            }
            this.setState({ markers: m });
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  drawMarker = (marker) => {
    let dIcon = L.icon({
      iconUrl: marker.img,
      iconAnchor: marker.type === 'O' ? [25, 30] : [13, 33],
      popupAnchor: [0, -25]
    });
    let newLatLng = new L.LatLng(marker.lat, marker.lng);
    let myLayer = L.marker(newLatLng, { icon: dIcon });
    myLayer._leaflet_id = marker.guid;
    myLayer.bindPopup(marker.name);
    myLayer.addTo(this.featureGroupPM);

    if (marker.r > 0) {
      let myStyle = {
        "color": 'red',
        "weight": 4,
        "opacity": 0.5,
        "radius": marker.r
      };
      myLayer = L.circle(newLatLng, myStyle);
      myLayer._leaflet_id = marker.guid + 'r';
      myLayer.addTo(this.featureGroupPM);
    }
  }

  checkMarkers = () => {
    let mapBounds = this.mymap.getBounds();
    for (let i = this.state.markers.length - 1; i >= 0; i--) {
      let m = this.mymap._layers[this.state.markers[i].guid];
      if (this.mymap.getZoom() > 11) {
        if (!m) {
          this.drawMarker(this.state.markers[i]);
        } else {
          let shouldBeVisible = mapBounds.contains(m.getLatLng());
          if (m._icon && !shouldBeVisible) {
            this.featureGroupPM.removeLayer(m);
            let mr = this.mymap._layers[this.state.markers[i].guid + 'r'];
            if (mr)
              this.featureGroupP.removeLayer(mr);
          }
        }
      } else if (m) {
        this.featureGroupPM.removeLayer(m);
        let mr = this.mymap._layers[this.state.markers[i].guid + 'r'];
        if (mr)
          this.featureGroupP.removeLayer(mr);
      }
    }
  };

  checkTitleMap = (list) => {
    for (let tag in this.polyNames) {
      if (list[2]) {
        const myLayer = this.mymap._layers[tag];
        if (myLayer !== undefined) {
          if (list[3]) {
            myLayer.unbindTooltip();
            myLayer.bindTooltip(this.polyNames[tag],
              { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
            ).openTooltip();
          } else {
            myLayer.unbindTooltip();
          }
        }
      }
    }
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleAircraftBrandChange = event => {
    const idAircraftBrand = event && event.target ? Number(event.target.value) : 0;

    this.setState({
      id_aircraftbrand: idAircraftBrand,
      id_aircraftmodel: 0
    });

    if (idAircraftBrand) {
      this.loadAircraftModels(idAircraftBrand);
    } else {
      this.setState({
        aircraftmodels: []
      });
    }
  };

  handleChangeTab = name => (event, newValue) => {
    this.setState({
      [name]: newValue ? newValue : event.target.value,
    });
  };

  zoomInL = () => {
    this.mymap.zoomIn();
  };

  zoomOutL = () => {
    this.mymap.zoomOut();
  };

  showMenu = () => {
    let dF = document.getElementById('divFloat');
    if (!dF.className.includes('div-listFloatP')) {
      dF.classList.toggle("div-listFloatP");
    } else {
      dF.classList.remove("div-listFloatP");
    }
  };

  handleStackClick = (tipo) => {
    let stack_value = this.state.stack_value;
    if (tipo === 1) {
      if (stack_value[0] === 1) {
        stack_value[0] = 0;
        tools.cssShow('aplicacao', false);
      } else {
        stack_value[0] = 1;
        tools.cssShow('aplicacao', true);
      }
      this.setState({ stack_value: stack_value });
    } else if (tipo === 2) {
      if (stack_value[1] === 1) {
        stack_value[1] = 0;
        tools.cssShow('caminho', false);
      } else {
        stack_value[1] = 1;
        tools.cssShow('caminho', true);
      }
      this.setState({ stack_value: stack_value });
    } else if (tipo === 3) {
      if (stack_value[2] === 1) {
        stack_value[2] = 0;
        tools.cssShow('area', false);
      } else {
        stack_value[2] = 1;
        tools.cssShow('area', true);
      }
      this.setState({ stack_value: stack_value });
    } else if (tipo === 4) {
      if (stack_value[3] === 1) {
        stack_value[3] = 0;
      } else {
        stack_value[3] = 1;
      }
      this.checkTitleMap(stack_value);
      this.setState({ stack_value: stack_value });
    } else if (tipo === 5) {
      if (stack_value[4] === 1) {
        stack_value[4] = 0;
        this.removeStationMarker();
      } else {
        stack_value[4] = 1;
        if (this.state.stationLatLng) {
          this.addStationImage(this.state.stationLatLng[0], this.state.stationLatLng[1]);
        }
      }
      this.setState({ stack_value: stack_value });
    }
  };

  addStationImage = (lat, lng) => {
    if (lat == null || lng == null) return;

    if (!this.stationMarker) {
      const stationIcon = L.icon({
        iconUrl: img[25]?.img,
        iconSize: [50, 50],
        iconAnchor: [25, 50],
        popupAnchor: [0, -50],
      });

      const stationLatLng = [lat, lng];
      this.stationMarker = L.marker(stationLatLng, { icon: stationIcon }).addTo(this.mymap);

      this.setState({ stationLatLng: [lat, lng] });
    } else {
      const stationLatLng = [lat, lng];
      this.stationMarker.setLatLng(stationLatLng);
    }
  };

  removeStationMarker = () => {
    if (this.stationMarker) {
      this.mymap.removeLayer(this.stationMarker);
      this.stationMarker = null;
    }
  };

  updatePer = (values, cost) => {
    const time = isNaN(this.state.time) ? 0 : this.state.time;
    let cVoo_temp = cost ? values[7][1] / 60 / 60 * cost : 0;

    let area_per = values[14][0] > 0 ? (values[14][1] * 100 / values[14][0] - 100).toFixed(2) * -1 : 0;
    let tVoo_per = values[0][0] > 0 ? (values[0][1] * 100 / values[0][0] - 100).toFixed(2) * -1 : 0;
    let cVoo_per = values[6][0] > 0 ? (cVoo_temp * 100 / values[6][0] - 100).toFixed(2) * -1 : 0;
    let totalApl_per = values[5][0] > 0 ? (values[5][1] * 100 / values[5][0] - 100).toFixed(2) * -1 : 0;
    let qtdFuel_per = !values[3][0] === 0 && !values[3][1] === 0 ? (values[3][1] * 100 / values[3][0] - 100).toFixed(2) * -1 : 0;

    let tTotal_per = values[7][0] > 0 ? (values[7][1] * 100 / values[7][0] - 100).toFixed(2) * -1 : 0;
    let tTotal_valor = ((cost * (values[7][0] / 60 / 60)) - (cost * (values[7][1] / 60 / 60))).toFixed(2);
    let tSolo_per = values[12][0] > 0 ? (values[12][1] * 100 / values[12][0] - 100).toFixed(2) * -1 : 0;
    let tSolo_valor = ((cost * (values[12][0] / 60 / 60)) - (cost * (values[12][1] / 60 / 60))).toFixed(2);
    let tTran_per = values[1][0] > 0 ? (values[1][1] * 100 / values[1][0] - 100).toFixed(2) * -1 : 0;

    let tTran_valor = ((cost * (values[1][0] / 60 / 60)) - (cost * (values[1][1] / 60 / 60))).toFixed(2);
    let tLoop_per = values[4][0] > 0 ? (values[4][1] * 100 / values[4][0] - 100).toFixed(2) * -1 : 0;

    let tLoop_valor = ((cost * (values[4][0] / 60 / 60)) - (cost * (values[4][1] / 60 / 60))).toFixed(2);
    let tApl_per = values[2][0] > 0 ? (values[2][1] * 100 / values[2][0] - 100).toFixed(2) * -1 : 0;

    let tApl_valor = ((cost * (values[2][0] / 60 / 60)) - (cost * (values[2][1] / 60 / 60))).toFixed(2);

    let vProf_exe = values[10][0] - cVoo_temp - values[8][0];
    let lhora_exe = vProf_exe / ((values[7][1] + time) / 3600);
    //let vPtemp = values[9][0] - vProf_exe;
    let vProf_per = (vProf_exe > 0 ? vProf_exe * 100 / values[9][0] - 100 : 0).toFixed(2);
    if (values[9][0] < 0) {
      vProf_per *= -1;
    }
    let vVooO_per = (values[10][0] > 0 ? values[9][0] * 100 / values[10][0] : 0).toFixed(2);
    let vVooR_per = (values[10][0] > 0 ? vProf_exe * 100 / values[10][0] : 0).toFixed(2);

    let vVooHA_temp = values[14][1] > 0 ? values[10][0] / values[14][1] : 0;
    let vVooHA_per = vVooHA_temp > 0 ? (vVooHA_temp * 100 / values[11][0] - 100).toFixed(2) : 0;
    let cVooHA_exe = values[14][1] > 0 ? cVoo_temp / values[14][1] : 0;
    let cVooHA_per = cVoo_temp > 0 ? (cVooHA_exe * 100 / values[13][0] - 100).toFixed(2) * -1 : 0;

    let vC_exe = cVoo_temp;
    let vC_per = vC_exe > 0 ? (vC_exe * 100 / values[15][0] - 100).toFixed(2) * -1 : 0;

    let rend_per = (values[16][0] > 0 ? values[16][1] * 100 / values[16][0] - 100 : 0).toFixed(2);

    this.setState({
      cVoo_exe: cost > 0 && values[0][1] > 0 ? cVoo_temp : 0,
      vImp_exe: values[8][0],
      vProf_exe: vProf_exe,
      lhora_exe: lhora_exe,
      vVoo_exe: values[10][0],
      vVooHA_exe: cost > 0 && values[0][1] > 0 ? vVooHA_temp : 0,

      vProf_per: vProf_per,
      vVooO_per: vVooO_per,
      vVooR_per: vVooR_per,
      area_per: area_per,

      vC_exe: vC_exe,
      vC_per: vC_per,

      tTotal_per: tTotal_per,
      tTotal_valor: tTotal_valor,
      tSolo_per: tSolo_per,
      tSolo_valor: tSolo_valor,
      tTran_per: tTran_per,
      tTran_valor: tTran_valor,
      tLoop_per: tLoop_per,
      tLoop_valor: tLoop_valor,
      tApl_per: tApl_per,
      tApl_valor: tApl_valor,

      tVoo_per: tVoo_per,
      cVoo_per: cVoo_per,
      totalApl_per: totalApl_per,
      qtdFuel_per: qtdFuel_per,

      cVooHA_exe: cVooHA_exe,
      vVooHA_per: vVooHA_per,
      cVooHA_per: cVooHA_per,

      rend_per: rend_per,
    }, () => {
      localStorage.setItem('c_report_map', JSON.stringify(this.state));
      this.setState({ downloadRelButton: true });
    });
  };

  markMap = (type, pos) => {
    let label = 'mark';
    if (type === 11) {
      if (this.state.base.length > 0) {
        this.featureGroupPoly.removeLayer(this.mymap._layers['base']);
      }
      this.setState({ base: pos });
      label = 'base';
    }
    let dIcon = L.icon({
      iconUrl: this.icon[type].img,
      iconAnchor: [13, 33]
    });
    let mark = L.marker(pos, { icon: dIcon });
    if (label === 'base') {
      mark._leaflet_id = label;
    }
    this.featureGroupPoly.addLayer(mark);
    this.mymap.fitBounds(this.featureGroupPoly.getBounds());
  };

  polyMap = (poly) => {
    const color_x = '#ff002b';
    let myStyle = {
      color: '#47839e',
      weight: 4,
      opacity: 0.5,
      fillColor: '#FF1493',
      fillOpacity: .7,
      className: 'area'
    };

    if (poly.type === 'X') {
      myStyle.color = color_x;
      myStyle.fillColor = color_x;
    }

    let myLayer = L.geoJSON(poly.poly, { style: myStyle });
    myLayer._leaflet_id = poly.guid + '_h';
    myLayer.addTo(this.featureGroupPoly);
    this.polyNames[poly.guid + '_h'] = poly.name;
  };

  abMap = (poly) => {
    if (poly.abData && poly.abData.line) {
      const { res } = this.props;
      const myStyle = {
        "color": '#f5c749',
        "weight": 2,
        "opacity": 1
      };
      let myLayer = L.geoJSON(poly.abData.line, { style: myStyle });
      myLayer.addTo(this.featureGroupPoly);


      const latlngs = poly.abData.line.geometry.coordinates;
      let imgIcon = Img_mark[8].img;

      let dIcon = L.icon({
        iconUrl: imgIcon,
        iconAnchor: [9, 30]
      });
      let newLatLng = new L.LatLng(latlngs[0][1], latlngs[0][0]);
      myLayer = L.marker(newLatLng, { icon: dIcon });
      myLayer.addTo(this.featureGroupPoly);

      const bearing = poly.abData.bearing < 0 ? 360 + poly.abData.bearing : poly.abData.bearing;
      const pop = res.ANGULO + ": " + bearing.toFixed() + 'º<br> ' +
        res.ESTRATEGIA + ': ' + poly.abData.strategy + '<br> ' +
        res.LARGURA_FAIXA + ': ' + Units.formatValue(Units.convertLength(poly.abData.width, 'm', res), res) + ' ' + Units.getLengthUnit(res) + '<br> ' +
        res.FLUXO_APLICACAO + ': ' + Units.formatValue(Units.convertFlow(poly.abData.setPoint, 'L', 'ha', res), res) + ' ' + Units.getFlowUnit(res, 'L');

      imgIcon = Img_mark[9].img;

      dIcon = L.icon({
        iconUrl: imgIcon,
        iconAnchor: [9, 30],
        popupAnchor: [9, -30]
      });
      newLatLng = new L.LatLng(latlngs[1][1], latlngs[1][0]);
      myLayer = L.marker(newLatLng, { icon: dIcon });
      myLayer.bindPopup(pop);
      myLayer.addTo(this.featureGroupPoly);

      imgIcon = Img_mark[22].img;

      dIcon = L.icon({
        iconUrl: imgIcon,
        iconAnchor: [-13, 35],
        popupAnchor: [9, -30]
      });
      dIcon.options.iconSize = [16, 16];
      newLatLng = new L.LatLng(latlngs[1][1], latlngs[1][0]);
      myLayer = L.marker(newLatLng, { icon: dIcon });
      myLayer.bindPopup(pop);
      myLayer.addTo(this.featureGroupPoly);

    }
  };

  aplMapCorrect = (poly) => {
    const { res } = this.props;

    let myStyle = {
      color: '#32a852',
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao'
    };

    const pop =
      '<b>' + res.TIRO + ': ' + poly.title + '</b><br> '
      + `${res.LARGURA_FAIXA}: ${Units.formatValue(Units.convertLength(poly.faixa, 'm', res), res)} ${Units.getLengthUnit(res)}<br> `
      + `${res.COMPRIMENTO}: ${Units.formatValue(Units.convertLength(poly.comprimento, 'm', res), res, 1)} ${Units.getLengthUnit(res)}<br> `
      + `${res.AREA}: ${Units.formatValue(Units.convertArea(poly.area, 'ha', res), res, 1)} ${Units.getAreaUnit(res)}<br> `
      + `${res.VOLUME}: ${Units.formatValue(Units.convertVolume(poly.volume, 'L', res), res, 1)} ${Units.getVolumeUnit(res, 'L')}<br> `
      + `${res.FLUXO_MEDIO}: ${Units.formatValue(Units.convertFlow(poly.fMedio, 'L', 'ha', res), res, 1)} ${Units.getFlowUnit(res, 'L')}`;

    let myLayer = L.geoJSON(poly.poly, { style: myStyle });
    myLayer.on("click", () => { this.handleClickAplMap(myLayer); });
    myLayer.bindPopup(pop);
    myLayer.addTo(this.featureGroupP);
  };

  handleClickAplMap = (layer) => {
    this.featureGroupP.eachLayer((item) => {
      item.setStyle({ color: '#32a852' });
    });
    if (layer) {
      layer.setStyle({ color: '#25c450' });
    }
  };

  pathMap = (line) => {
    let myStyle = {
      color: '#d0d0d0',
      weight: 1,
      opacity: 1,
      smoothFactor: 1,
      className: 'caminho'
    };

    let myLayer = L.geoJSON(line, { style: myStyle });
    myLayer.addTo(this.featureGroupL);
  };

  aplMap = (poly) => {
    let myStyle = {
      color: "#ffd12b",
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao'
    };

    let myLayer = L.geoJSON(poly, { style: myStyle });
    myLayer.addTo(this.featureGroupP);
  };

  regua = (start) => {
    if (this.state.create) {
      this.cancelCreate();
    }
    if (this.state.edit) {
      this.cancelEdit();
    }

    this.featureGroupPoly.removeLayer(this.mymap._layers['regua']);
    this.featureGroupPoly.removeLayer(this.mymap._layers['reguaM1']);
    this.featureGroupPoly.removeLayer(this.mymap._layers['reguaM2']);
    if (!start && (this.state.ruler_a || this.ruler_p.first.lat)) {
      this.setState({ ruler_a: false });
      this.ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };
      if (this.drawCreateToolbar) {
        this.drawCreateToolbar.disable();
      }
    } else {
      this.setState({ ruler_a: true });
      this.drawCreateToolbar = new L.Draw.Polyline(this.mymap);
      this.drawCreateToolbar.enable();
      if (start) {
        this.drawCreateToolbar.addVertex(start);
      }
    }
  };

  completeRuler = () => {
    if (this.drawCreateToolbar) {
      this.drawCreateToolbar.disable();
    }
    let latlngs = [
      [this.ruler_p.first.lat, this.ruler_p.first.lng],
      [this.ruler_p.second.lat, this.ruler_p.second.lng]
    ];
    let latlngF = L.latLng([this.ruler_p.first.lat, this.ruler_p.first.lng]);
    let latlngS = L.latLng([this.ruler_p.second.lat, this.ruler_p.second.lng]);
    let text = latlngF.distanceTo(latlngS);


    let polyline = L.polyline(latlngs);

    polyline._leaflet_id = 'regua';
    polyline.bindTooltip(this.formatRegua(text), { permanent: true }).openTooltip()
    polyline.addTo(this.featureGroupPoly);

    let m1 = L.marker([this.ruler_p.first.lat, this.ruler_p.first.lng], {
      icon: new L.DivIcon({
        iconSize: new L.Point(10, 10),
        className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
      })
    })
    m1.on('click', (e) => {
      this.regua([this.ruler_p.second.lat, this.ruler_p.second.lng]);
    })
    m1._leaflet_id = 'reguaM1';
    m1.addTo(this.featureGroupPoly);

    let m2 = L.marker([this.ruler_p.second.lat, this.ruler_p.second.lng], {
      icon: new L.DivIcon({
        iconSize: new L.Point(10, 10),
        className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
      })
    });
    m2.on('click', (e) => {
      this.regua([this.ruler_p.first.lat, this.ruler_p.first.lng]);
    })
    m2._leaflet_id = 'reguaM2';
    m2.addTo(this.featureGroupPoly);
  };

  cancelRuler = () => {
    if (this.ruler_p.second.lat) {
      this.regua();
    }
  };

  formatRegua = (valor) => {
    let text = '';
    if (valor < 1000) {
      text = Math.round(valor) + ' m';
    } else {
      text = (Math.round(valor / 10) / 100) + ' km';
    }

    return text;
  };

  formatCoordinateByMode = (value, type) => {
    if (value == null || value === '' || !isFinite(Number(value))) return '';

    if ((this.state.coordMode || 'dd') === 'dd') {
      return Number(value).toFixed(6);
    }

    return geo.toDMS(Number(value), type, 4, this.props.res);
  };

  toggleCoordMode = () => {
    const nextMode = (this.state.coordMode || 'dd') === 'dd' ? 'dms' : 'dd';

    this.setState({ coordMode: nextMode }, () => {
      if (this.waypointMarker) {
        const latlng = this.waypointMarker.getLatLng();
        this.waypointMarker.setPopupContent(this.formatWaypointPopup(latlng));
        this.openWaypointPopup();
      }
    });
  };

  buildWaypointIcon = () => {
    if (this.waypointIcon) return this.waypointIcon;

    this.waypointIcon = L.icon({
      iconUrl: pinWaypoint,
      iconSize: [30, 30],
      iconAnchor: [15, 30],
      popupAnchor: [0, -28]
    });

    return this.waypointIcon;
  };

  formatWaypointPopup = (latlng) => {
    const latText = latlng && latlng.lat != null ? this.formatCoordinateByMode(latlng.lat, 'latitude') : '';
    const lngText = latlng && latlng.lng != null ? this.formatCoordinateByMode(latlng.lng, 'longitude') : '';
    const modeLabel = (this.state.coordMode || 'dd') === 'dd'
      ? (this.props.res.COORDENADA_DD || 'Graus Decimais (DD)')
      : (this.props.res.COORDENADA_DMS || 'Graus, Minutos e Segundos (DMS)');

    return `
      <div style="font-size: 12px; line-height: 1.35;">
        <div><b>${this.props.res.LAT || 'LAT'}:</b> ${latText}</div>
        <div><b>${this.props.res.LNG || 'LNG'}:</b> ${lngText}</div>
      </div>
    `;
  };

  openWaypointPopup = () => {
    if (this.waypointMarker) {
      this.waypointMarker.openPopup();
    }
  };

  closeWaypointPopup = () => {
    if (this.waypointMarker) {
      this.waypointMarker.closePopup();
    }
  };

  createWaypointMarker = (latlng) => {
    const icon = this.buildWaypointIcon();

    const marker = L.marker(latlng, {
      icon: icon,
      keyboard: false
    });

    marker.bindPopup(this.formatWaypointPopup(latlng), {
      closeButton: true,
      autoClose: false,
      closeOnClick: false
    });

    marker.on('click', (ev) => {
      if (ev && ev.originalEvent) {
        L.DomEvent.stopPropagation(ev.originalEvent);
      }
      this.openWaypointPopup();
    });

    marker.addTo(this.mymap);

    this.waypointMarker = marker;
    this.openWaypointPopup();
  };

  moveWaypointMarker = (latlng) => {
    if (!this.waypointMarker) {
      this.createWaypointMarker(latlng);
      return;
    }

    this.waypointMarker.setLatLng(latlng);
    this.waypointMarker.setPopupContent(this.formatWaypointPopup(latlng));
    this.openWaypointPopup();
  };

  keyCell = 0;

  item_title = (res) => {
    return (
      <TableRow key={this.keyCell++}>
        <TableCell component="th" scope="row" colSpan={4} style={{ borderBottom: 0 }}>
          <div className="titleTextRel">
            {res}
          </div>
        </TableCell>
      </TableRow>
    );
  };

  item_value = (exe, exe_valor, total_valor) => {
    const per_exe = exe_valor ? this.timePercentual(total_valor, exe_valor) : false;
    const exe_temp = per_exe && '';
    return (<TableRow key={this.keyCell++}>
      <TableCell component="th" scope="row"></TableCell>
      <TableCell component="th" scope="row"></TableCell>
      <TableCell align="right" style={{ position: 'relative' }}><span>{exe}</span>{exe_temp}</TableCell>
    </TableRow>);
  };

  checkTask = async (item, pro) => {
    const temp_pro = pro;
    const apiUrl = Config.server + '/getResult/' + item;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    this.setState({ progress: true, progressValue: 0, openTask: false });
    let result;
    try {
      const response = await fetch(apiUrl, options);
      result = await Calls.toJSON(response.headers.get('content-length'), response.body,
        (loaded, length) => {
          this.setState({ progressValue: (100 * loaded / length).toFixed() });
        });
    } catch (error) {
      this.setState({ progress: false, progressValue: 0 });
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }
    this.setState({ progressValue: 0 });
    if (!result) {
      this.setState({ progress: false, progressValue: 0 });
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    } else if (result && result.code) {
      this.setState({ progress: false, progressValue: 0 });
      notification.open({
        message: result.message,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    if (result === 'file not found.') {
      this.setState({ progress: false, openTask: true }, () => {
        this.loadTask(true);
      });
    } else {

      const data = JSON.parse(result);
      const polyData = data.polygons;
      const serviceOrder = data.service_order || null;
      const serviceOrderJob = serviceOrder && serviceOrder.job ? serviceOrder.job : null;
      const planeData = serviceOrderJob && serviceOrderJob.plane_data ? serviceOrderJob.plane_data : null;

      let ordemServico = '';
      if (serviceOrder) {
        const serviceOrderTitle = serviceOrder.title ? serviceOrder.title : '';
        const serviceOrderNumber = serviceOrder.order_number ? serviceOrder.order_number : '';

        if (serviceOrderTitle && serviceOrderNumber) {
          ordemServico = serviceOrderTitle + ' - ' + serviceOrderNumber;
        } else if (serviceOrderTitle) {
          ordemServico = serviceOrderTitle;
        } else if (serviceOrderNumber) {
          ordemServico = serviceOrderNumber;
        }
      }

      localStorage.setItem('report_check-task', item);
      this.setState({ task: item });
      if (temp_pro) {
        this.setState({ valor: 0, time: 0 }, () => { this.useData(JSON.parse(result)) });;
      } else {
        this.useData(JSON.parse(result));
      }
      setTimeout(() => {
        this.addKm();
      }, 40);

      let velSet, altSet, sprSet, swathwidth_exe;
      for (let i = 0; i < polyData.length; i++) {
        if (polyData[i].type !== 'Z') {
          sprSet = polyData[i].abData.setPoint;
          swathwidth_exe = polyData[i].abData.swathWidth;
          velSet = polyData[i].abData.targetspeed ? (polyData[i].abData.targetspeed * 3.6).toFixed(2) : null;
          altSet = polyData[i].abData.targetheight ? polyData[i].abData.targetheight.toFixed(2) : null;
          break;
        }
      }

      const idAircraftBrand = planeData && planeData.id_aircraftbrand ? Number(planeData.id_aircraftbrand) : 0;
      const idAircraftModel = planeData && planeData.id_aircraftmodel ? Number(planeData.id_aircraftmodel) : 0;

      this.setState({
        velApl_exe: data.apl && data.apl.vApl ? (data.apl.vApl * 3.6).toFixed(2) : null,
        sprApl_exe: data.apl && data.apl.mApl ? data.apl.mApl.toFixed(2) : null,
        altApl_exe: data.apl && data.apl.aApl ? data.apl.aApl.toFixed(2) : null,
        velSet,
        altSet,
        sprSet,
        swathwidth_exe,
        titulo: data.title || '',
        cliente: serviceOrder && serviceOrder.client ? serviceOrder.client : (data.customerName || ''),
        areaTotalAplicada: serviceOrderJob && serviceOrderJob.area ? serviceOrderJob.area : (data.apl && data.apl.area_aplicada ? data.apl.area_aplicada.toFixed(2) : ''),
        selectedProperty: serviceOrder && serviceOrder.property ? serviceOrder.property : '',
        customPropertyName: '',
        isCustomProperty: '',
        ordemServico: ordemServico,
        observacoes: serviceOrder && serviceOrder.observation ? serviceOrder.observation : '',
        nomePiloto: serviceOrderJob && serviceOrderJob.pilot ? serviceOrderJob.pilot : '',
        aeronavePrefixT: serviceOrderJob && serviceOrderJob.plane ? serviceOrderJob.plane : (data.aeronavePrefix || data.planeName || data.plane || ''),
        id_aircraftbrand: idAircraftBrand,
        id_aircraftmodel: 0,
        poligonos: data.polygons,
        talhoes: data.polygons.map((polygon) => {
          const coordinates = polygon.poly && polygon.poly.geometry && polygon.poly.geometry.coordinates && polygon.poly.geometry.coordinates[0]
            ? polygon.poly.geometry.coordinates[0]
            : [];

          return {
            name: polygon.name || '',
            latitude: coordinates[0] ? coordinates[0][1] : '',
            longitude: coordinates[0] ? coordinates[0][0] : '',
          };
        }),
      }, () => {
        if (idAircraftBrand > 0) {
          const hasAircraftBrand = (this.state.aircraftbrands || []).find((item) => Number(item.id) === idAircraftBrand);
          const loadBrands = hasAircraftBrand ? Promise.resolve() : this.loadAircraftBrands();

          loadBrands
            .then(() => this.loadAircraftModels(idAircraftBrand))
            .then(() => {
              this.setState({
                id_aircraftmodel: idAircraftModel
              });
            });
        }
      });

      const validPolygons = polyData.filter(
        (polygon, index, array) =>
          polygon.time_ini &&
          polygon.time_fim &&
          (!polygon.guid || array.findIndex(item => item && item.guid === polygon.guid) === index)
      );

      if (validPolygons.length > 0) {
        const polygonsWithoutClimateData = [];
        const polygonsWithClimateData = [];

        for (const polygon of validPolygons) {
          const climateData = await this.checkPolygonClimateData(polygon.guid, data.id);

          if (climateData.length > 0) {
            polygonsWithClimateData.push(...climateData);
          } else {
            polygonsWithoutClimateData.push(polygon);
          }
        }

        if (polygonsWithoutClimateData.length > 0) {
          await this.listWeatherDataByLocation(polygonsWithoutClimateData, data.id);
        }
      }
    }
  };

  checkPolygonClimateData = async (guid, id_job) => {
    const apiUrl = `${Config.server}/polygon_climate/${id_job}/${guid}`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    try {
      const response = await fetch(apiUrl, options);
      if (response.status !== 200) throw response;

      const data = await response.json();
      if (data.length > 0) {
        const formattedData = data.map((item) => {
          const stationsStartData = JSON.parse(item.stationsStartData || '[]');
          const stationsEndData = JSON.parse(item.stationsEndData || '[]');
          const selectedIdSource = item.id_source;

          const orderedStartData = [
            ...(stationsStartData.filter(data => data.id_source === selectedIdSource)),
            ...stationsStartData.filter(data => data.id_source !== selectedIdSource)
          ];

          const orderedEndData = [
            ...(stationsEndData.filter(data => data.id_source === selectedIdSource)),
            ...stationsEndData.filter(data => data.id_source !== selectedIdSource)
          ];

          if (orderedStartData.length > 0) {
            const lat = parseFloat(orderedStartData[0].lat);
            const lng = parseFloat(orderedStartData[0].lng);
            if (!isNaN(lat) && !isNaN(lng)) {
              this.removeStationMarker();
              this.addStationImage(lat, lng);
            }
          }

          return {
            id: item.id || null,
            id_job: item.id_job || null,
            guid: item.guid,
            lat: item.lat || null,
            lng: item.lng || null,
            startData: orderedStartData,
            endData: orderedEndData,
            selectedIdSource
          };
        });

        const currentData = formattedData
          .slice()
          .sort((a, b) => Number(b.id || 0) - Number(a.id || 0))[0] || null;

        this.setState((prevState) => {
          const weatherData = (prevState.weatherData || []).filter(item => item && item.guid !== guid);
          if (currentData) weatherData.push(currentData);

          const newStack = [...prevState.stack_value];
          newStack[4] = 1;

          return { weatherData, stack_value: newStack };
        });

        return currentData ? [currentData] : [];
      } else {
        this.setState((prevState) => {
          const newStackValue = [...prevState.stack_value];
          newStackValue[4] = 0;
          return { stack_value: newStackValue };
        });

        return [];
      }
    } catch (error) {
      this.setState({ progress: false });
      if (error.status === 405) {
        notification.open({
          message: this.props.res.PERMISSAO,
          description: this.props.res.PERMISSAO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />,
        });
      } else if (error.status === 401 || error.status === 403) {
        this.props.link('/login');
      } else {
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />,
        });
      }
      return [];
    }
  };

  listWeatherDataByLocation = async (polyData, id_job) => {
    const { res } = this.props;
    const newWeatherData = [...this.state.weatherData];

    for (const polygon of polyData) {
      const { time_ini, time_fim, poly, guid } = polygon;

      if (!time_ini || !time_fim) continue;

      const [lng, lat] = poly.geometry.coordinates[0][0];

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
        },
      };

      try {
        const responseIni = await fetch(`${Config.server}/weather_data/location/${lat}/${lng}/${time_ini}`, options);
        if (responseIni.status !== 200) throw responseIni;
        const resultIni = await responseIni.json();

        const responseFim = await fetch(`${Config.server}/weather_data/location/${lat}/${lng}/${time_fim}`, options);
        if (responseFim.status !== 200) throw responseFim;
        const resultFim = await responseFim.json();

        const newStartData = resultIni.map(data => ({
          ...data,
          lat: parseFloat(data.lat),
          lng: parseFloat(data.lng),
          id_source: data.id_source,
          startDate: data.datetime,
          startDateApplication: time_ini,
          thermalInversion: !data?.temperature
            ? res.DESABILITADO
            : data?.air_temperature - 5 > data?.temperature
              ? res.GRANDES_INVERSÃO_TERMICA
              : data?.air_temperature - 1 > data?.temperature
                ? res.PODE_ESTAR_INVERSÃO_TERMICA
                : res.NAO_OCORRENDO_INVERSAO_TERMICA,
        }));

        const newEndData = resultFim.map(data => ({
          ...data,
          lat: parseFloat(data.lat),
          lng: parseFloat(data.lng),
          id_source: data.id_source,
          endDate: data.datetime,
          endDateApplication: time_fim,
          thermalInversion: !data?.temperature
            ? res.DESABILITADO
            : data?.air_temperature - 5 > data?.temperature
              ? res.GRANDES_INVERSÃO_TERMICA
              : data?.air_temperature - 1 > data?.temperature
                ? res.PODE_ESTAR_INVERSÃO_TERMICA
                : res.NAO_OCORRENDO_INVERSAO_TERMICA,
        }));

        const newStartIds = newStartData.map(d => d.id_source);
        const newEndIds = newEndData.map(d => d.id_source);

        const existingIndex = newWeatherData.findIndex(d => d.guid === guid);

        if (existingIndex !== -1) {
          const existing = newWeatherData[existingIndex];

          const preservedStart = existing.startData.filter(d => newStartIds.includes(d.id_source));
          const preservedEnd = existing.endData.filter(d => newEndIds.includes(d.id_source));

          const addedStart = newStartData.filter(newStart => !preservedStart.some(start => start.id_source === newStart.id_source));
          const addedEnd = newEndData.filter(newEnd => !preservedEnd.some(end => end.id_source === newEnd.id_source));

          const finalStartData = [...preservedStart, ...addedStart];
          const finalEndData = [...preservedEnd, ...addedEnd];

          let updatedLat = lat;
          let updatedLng = lng;
          const selectedId = existing.selectedIdSource;

          if (selectedId) {
            const stationFromState = [...finalStartData, ...finalEndData].find(d => d.id_source === selectedId);
            if (stationFromState) {
              updatedLat = parseFloat(stationFromState.lat);
              updatedLng = parseFloat(stationFromState.lng);
            }
          }

          newWeatherData[existingIndex] = {
            ...existing,
            lat: updatedLat,
            lng: updatedLng,
            startData: finalStartData,
            endData: finalEndData,
          };

          if (!isNaN(updatedLat) && !isNaN(updatedLng) && (finalStartData.length || finalEndData.length)) {
            this.removeStationMarker();
            this.addStationImage(updatedLat, updatedLng);
          }

        } else {
          const finalStartData = newStartData;
          const finalEndData = newEndData;

          let defaultLat = null;
          let defaultLng = null;
          let selectedIdSource = null;

          const station = [...finalStartData, ...finalEndData][0];
          if (station && !isNaN(station.lat) && !isNaN(station.lng)) {
            defaultLat = station.lat;
            defaultLng = station.lng;
            selectedIdSource = station.id_source;
          }

          newWeatherData.push({
            guid,
            id_job,
            lat: defaultLat,
            lng: defaultLng,
            startData: finalStartData,
            endData: finalEndData,
            selectedIdSource,
          });

          if (defaultLat && defaultLng) {
            this.removeStationMarker();
            this.addStationImage(defaultLat, defaultLng);
          }
        }

      } catch (error) {
        notification.open({
          message: 'Erro ao buscar dados climáticos',
          description: error.message,
          icon: <MaterialIcon icon="error" className="text-danger" />,
        });
      }
    }

    this.setState({ weatherData: newWeatherData }, async () => {
      for (const data of newWeatherData) {
        const hasStartData = Array.isArray(data.startData) && data.startData.length > 0;
        const hasEndData = Array.isArray(data.endData) && data.endData.length > 0;

        if (data && data.guid && (hasStartData || hasEndData)) {
          await this.savePolygonClimateData(data);
        }
      }
    });
  };

  savePolygonClimateData = async (polygonData) => {
    const normalizeArray = (data) =>
      Array.isArray(data) ? data : (data ? [data] : []);

    const startDataArray = normalizeArray(polygonData.startData);
    const endDataArray = normalizeArray(polygonData.endData);

    // Descobre qual fonte está sendo usada:
    // 1) selectedIdSource definido
    // 2) senão, id_source do primeiro start/end
    // 3) se não tiver, fica null (manual)
    let selectedStationId;

    if (polygonData.selectedIdSource !== undefined) {
      selectedStationId = polygonData.selectedIdSource;
    } else if (startDataArray[0]?.id_source !== undefined) {
      selectedStationId = startDataArray[0].id_source;
    } else if (endDataArray[0]?.id_source !== undefined) {
      selectedStationId = endDataArray[0].id_source;
    } else {
      selectedStationId = null;
    }

    const filteredStartData =
      startDataArray.find(d => (d.id_source ?? null) === (selectedStationId ?? null)) || {};

    const filteredEndData =
      endDataArray.find(d => (d.id_source ?? null) === (selectedStationId ?? null)) || {};

    const updatedPolygonData = {
      stationsStartData: startDataArray,
      stationsEndData: endDataArray,
      guid: polygonData.guid,
      id_job: polygonData.id_job,
      lat: polygonData.lat,
      lng: polygonData.lng,
      startData: filteredStartData,
      endData: filteredEndData,
      selectedIdSource: selectedStationId, // pode ser null para manual
    };

    const apiUrl = polygonData.id
      ? `${Config.server}/polygon_climate/${polygonData.id}`
      : `${Config.server}/polygon_climate`;

    const method = polygonData.id ? 'PUT' : 'POST';

    const options = {
      method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedPolygonData),
    };

    try {
      const response = await fetch(apiUrl, options);
      if (!response.ok) {
        throw new Error(`Erro ao ${polygonData.id ? 'atualizar' : 'criar'} os dados climáticos no banco`);
      }

      if (!polygonData.id) {
        this.checkPolygonClimateData(polygonData.guid, polygonData.id_job);
      }
    } catch (error) {
      notification.open({
        message: 'Erro',
        description: `Erro ao ${polygonData.id ? 'atualizar' : 'criar'} os dados climáticos.`,
        icon: <MaterialIcon icon="error" className="text-danger" />,
      });
    }
  };

  useData = (result) => {
    if (result && result.tVoo) {
      if (result.linha) {
        this.featureGroupL.eachLayer((layer) => {
          this.featureGroupL.removeLayer(layer);
        });

        this.featureGroupPoly.eachLayer((layer) => {
          this.featureGroupPoly.removeLayer(layer);
        });
        for (let i = 0; i < result.polygons.length; i++) {
          const element = result.polygons[i];

          if (element.type === 'T') continue;

          this.polyMap(element);
        }
        if (this.state.stack_value[3]) {
          this.checkTitleMap(this.state.stack_value);
        }

        this.pathMap(result.linha);
        this.featureGroupP.eachLayer((layer) => {
          this.featureGroupP.removeLayer(layer);
        });
        for (let i = 0; i < result.apl.aplicacao.length; i++) {
          const element = result.apl.aplicacao[i];
          this.aplMapCorrect(element);
        }

        for (let i = 0; i < result.fuel.arrFuel.length; i++) {
          const element = result.fuel.arrFuel[i];
          this.markMap(0, [element.pos[0][1], element.pos[0][0]]);
        }

        if (this.state.base.length > 0) {
          this.markMap(11, this.state.base);
        }

        if (result.polygons.length) {
          this.mymap.fitBounds(this.featureGroupPoly.getBounds());
        }

        for (let i = 0; i < result.polygons.length; i++) {
          const element = result.polygons[i];
          this.abMap(element);
        }

        const velAverage = (result.apl.tApl * result.apl.vApl + result.travel.tTravel * result.travel.vTravel + result.loop.tLoop * result.loop.vLoop) / (result.apl.tApl + result.travel.tTravel + result.loop.tLoop);

        if (result.climate) {
          this.setState({
            windSpeedFirst: result.climate.first.windspeed ? parseInt(result.climate.first.windspeed) : '',
            windSpeedLast: result.climate.last.windspeed ? parseInt(result.climate.last.windspeed) : '',
            windHeadingFirst: result.climate.first.windheading ? result.climate.first.windheading : '',
            windHeadingLast: result.climate.last.windheading ? result.climate.last.windheading : '',
            temperatureFirst: result.climate.first.temperature ? result.climate.first.temperature : '',
            temperatureLast: result.climate.last.temperature ? result.climate.last.temperature : '',
            airRHFirst: result.climate.first.airrh ? result.climate.first.airrh : '',
            airRHLast: result.climate.last.airrh ? result.climate.last.airrh : ''
          });
        } else {
          this.setState({
            windSpeedFirst: '',
            windSpeedLast: '',
            windHeadingFirst: '',
            windHeadingLast: '',
            temperatureFirst: '',
            temperatureLast: '',
            airRHFirst: '',
            airRHLast: ''
          })
        }
        let days = [], dtIni, dtFim;
        if (result.days) {
          for (let index = 0; index < result.days.length; index++) {
            const element = new Date(result.days[index].date);
            if (!days.find(a => (a.getDate() === element.getDate() && a.getMonth() === element.getMonth() && a.getFullYear() === element.getFullYear()))) {
              days.push(element);
            }
          }
          dtIni = new Date(result.days[0].date);
          dtFim = new Date(result.days[result.days.length - 1].date);
          dtFim.setSeconds(dtFim.getSeconds() + result.days[result.days.length - 1].time);
        }
        this.setState({
          id: result.id,
          guid_link: result.guid,
          dtIni,
          dtFim,
          fimAplicacao: dtFim,
          job_guid: this.state.job_guid ? this.state.job_guid : this.state.job_guid_b ? this.state.job_guid_b : this.props.guid,
          guid: result.guid,
          percSize: result.perc ? result.perc : 100,
          title: result.title,
          title_sk: result.title_sk,
          aeronavePrefixT: result.aeronavePrefix,
          customerNameT: result.customerName,
          cVoo_exe: result.cVoo,
          area_exe: result.apl.area_aplicada,
          tTotal_exe: result.tTotal,
          tVoo_exe: result.tVoo,
          tSolo_exe: result.tTotal - result.tVoo,
          tTran_exe: result.travel.tTravel + result.fuel.tFuelS,
          tApl_exe: result.apl.tApl,
          tFuel_exe: result.fuel.tFuelS,
          qtdFuel_exe: result.fuel.qtdFuel,
          tLoop_exe: result.loop.tLoop,
          totalApl_exe: Math.ceil(result.apl.totalApl),
          vC_exe: 0,
          dias_exe: days,
          velAverage: (velAverage * 3.6).toFixed(2),
          velApl_exe: (result.apl.vApl * 3.6).toFixed(2),
          velTrans_exe: (result.fuel.vFuelS * 3.6).toFixed(2),
          velLoop_exe: (result.loop.vLoop * 3.6).toFixed(2),
          rend_exe: (result.apl.area_aplicada / (result.tTotal / 3600)),
          progress: false,
          arrFuel: result.fuel.arrFuel
        }, () => {
          localStorage.setItem('c_report_map', JSON.stringify(this.state));
        });
        if (this.state.tVoo_est) {
          this.updatePer([
            [this.state.tVoo_est, result.tVoo],
            [this.state.tTran_est, result.travel.tTravel + result.fuel.tFuelS],
            [this.state.tApl_est, result.apl.tApl],
            [this.state.qtdFuel_est, result.fuel.qtdFuel],
            [this.state.tLoop_est, result.loop.tLoop],
            [this.state.totalApl_est, Math.ceil(result.apl.totalApl)],
            [this.state.cVoo_est, result.cVoo],                     //6
            [this.state.tTotal_est, result.tTotal],                 //7
            [this.state.vImp_est, result.vImp],                     //8
            [this.state.vProf_est, result.vProf],                   //9
            [this.state.vVoo_est, result.vVoo],                     //10
            [this.state.vVooHA_est, result.apl.area_aplicada],      //11
            [this.state.tSolo_est, result.tTotal - result.tVoo],    //12
            [this.state.cVooHA_est, result.apl.area_aplicada],      //13
            [this.state.area_est, result.apl.area_aplicada],        //14
            [this.state.vC_est, 0],                                 //15
            [this.state.rend_est, (result.apl.area_aplicada / (result.tTotal / 3600))],                               //16
          ], this.state.cost);
        }
        this.readJob(result.id)
        this.readReportOperational(result.id)
        /////---------------------
      } else {
        this.area = result.apl.area_aplicada;
        let base = result.base ? JSON.parse(result.base) : [];
        if (base.length > 0) {
          this.markMap(11, base);
        }
        const temp_area = result.vVoo / result.apl.area_aplicada;
        const vCost = (result.vVoo - result.vProf - result.vImp);

        this.setState({
          aeronavePrefixO: result.aeronavePrefix,
          customerNameO: result.customerName,
          cost: result.cost,
          area_est: result.apl.area_aplicada,
          cVoo_est: result.cVoo,
          vImp_est: result.vImp,
          vProf_est: result.vProf,
          vVoo_est: result.vVoo,
          vVooHA_est: temp_area,
          tTotal_est: result.tTotal,
          tVoo_est: result.tVoo,
          tSolo_est: (result.tTotal - result.tVoo) > 0 ? (result.tTotal - result.tVoo) : 0,
          tTran_est: result.travel.tTravel,
          tApl_est: result.apl.tApl,
          tFuel_est: result.fuel.tFuelS,
          qtdFuel_est: result.fuel.qtdFuel,
          tLoop_est: result.loop.tLoop,
          totalApl_est: Math.ceil(result.apl.totalApl),
          cVooHA_est: vCost / result.apl.area_aplicada,
          vC_est: vCost,
          dias_est: Math.ceil((result.tTotal / 60 / 60) / result.days),
          velApl_est: result.apl.vApl,
          velTrans_est: result.travel.vTravel,
          velLoop_est: result.loop.vLoop,
          difficulty: result.difficulty,
          rend_est: (result.apl.area_aplicada / (result.tTotal / 3600)),
          lhora_est: result.vProf / (result.tTotal / 3600),
          progress: false
        }, () => { localStorage.setItem('c_report_map', JSON.stringify(this.state)); });
        if (this.state.tVoo_exe) {
          this.updatePer([
            [result.tVoo, this.state.tVoo_exe + this.state.time],                       //0
            [result.travel.tTravel, this.state.tTran_exe + this.state.time],            //1
            [result.apl.tApl, this.state.tApl_exe],                   //2
            [result.fuel.qtdFuel, this.state.qtdFuel_exe],            //3
            [result.loop.tLoop, this.state.tLoop_exe],                //4
            [Math.ceil(result.apl.totalApl), this.state.totalApl_exe],//5
            [result.cVoo, this.state.cVoo_exe],                       //6
            [result.tTotal, this.state.tTotal_exe + this.state.time],                   //7
            [result.vImp, this.state.vImp_exe],                       //8
            [result.vProf, this.state.vProf_exe],                     //9
            [result.vVoo, this.state.vVoo_exe],                       //10
            [temp_area, this.state.vVooHA_exe],                       //11
            [result.tTotal - result.tVoo, this.state.tSolo_exe],      //12
            [vCost / result.apl.area_aplicada, this.state.cVooHA_exe],//13
            [result.apl.area_aplicada, this.state.area_exe],          //14
            [vCost, 0],      //15
            [(result.apl.area_aplicada / (result.tTotal / 3600)), this.state.rend_exe],          //14
          ], result.cost);
        }
      }
    } else {
      if (!result) {
        this.setState({ progress: false });
        notification.open({
          message: this.props.res.PROCESSANDO_,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }
    }
  };

  loadTask = (open) => {
    let apiUrl = Config.server + '/task/report'
    let guid = this.state.job_guid ? this.state.job_guid : this.state.job_guid_b ? this.state.job_guid_b : this.props.guid;
    if (guid) {
      apiUrl += '/' + guid;
    } else {
      return;
    }

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result.length > 0) {
            setTimeout(() => {
              if (this.state.openTask) {
                this.loadTask(true);
              }
            }, 3000);
            let itens = [];
            for (let i = 0; i < result.length; i++) {
              itens.push({ id: result[i].id, title: result[i].title, progress: result[i].progress });
            }
            this.setState({
              itensTask: itens,
              openTask: open
            });
          } else {
            this.setState({ itensTask: [] });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  clear = () => {
    localStorage.setItem('c_report_map', JSON.stringify(this.base_state));
    this.setState(JSON.parse(JSON.stringify(this.base_state)));

    this.featureGroupL.clearLayers();
    this.featureGroupP.clearLayers();
    this.featureGroupPoly.clearLayers();
    localStorage.setItem('report_check-task', null);
  };

  addKm = () => {
    let time = isNaN(this.state.velTrans_exe) || (!isNaN(this.state.velTrans_exe) && Number(this.state.velTrans_exe) === 0) ? 0 : this.state.valor / Number(this.state.velTrans_exe) * 3600;
    let rend = (this.state.area_exe / ((this.state.tTotal_exe + time) / 3600))
    this.setState({ time: time, rend_exe: rend, addKm: false },
      this.updatePer([
        [this.state.tVoo_est, this.state.tVoo_exe + time],                     //0
        [this.state.tTran_est, this.state.tTran_exe + time],                   //1
        [this.state.tApl_est, this.state.tApl_exe],                     //2
        [this.state.qtdFuel_est, this.state.qtdFuel_exe],               //3
        [this.state.tLoop_est, this.state.tLoop_exe],                   //4
        [this.state.totalApl_est, this.state.totalApl_exe],             //5
        [this.state.cVoo_est, this.state.cVoo_exe],                     //6
        [this.state.tTotal_est, this.state.tTotal_exe + time],                 //7
        [this.state.vImp_est, this.state.vImp_exe],                     //8
        [this.state.vProf_est, this.state.vProf_exe],                   //9
        [this.state.vVoo_est, this.state.vVoo_exe],                     //10
        [this.state.vVooHA_est, this.state.vVooHA_exe],                 //11
        [this.state.tSolo_est, this.state.tSolo_exe],                   //12
        [this.state.cVooHA_est, this.state.cVooHA_exe],                 //13
        [this.state.area_est, this.state.area_exe],                     //14
        [this.state.vC_est, this.state.vC_exe],                         //15
        [this.state.rend_est, rend],                     //16
      ], this.state.cost)
    );
  };

  callNew = () => {
    this.setState({ clear: true, new: { msg: this.props.res.NOVA_AVALIACAO_CONFIRM, func: this.clear } });
  };

  timePercentual = (timeTotal, timeParcial) => {
    return Math.round(100 * timeParcial / timeTotal);
  }

  downloadRA = (id, arrFuel) => {
    this.setState({ progress: true });

    let apiUrl = Config.server + '/relaplicacao';
    let method = 'POST';

    let aircraftbrand;
    if (this.state.id_aircraftbrand > 0) {
      aircraftbrand = this.state.aircraftbrands.filter(brand => {
        return brand.id === this.state.id_aircraftbrand;
      })
    }

    let aircraftmodel;
    if (this.state.id_aircraftmodel > 0) {
      aircraftmodel = this.state.aircraftmodels.filter(model => {
        return model.id === this.state.id_aircraftmodel;
      })
    }

    let data = {
      culture: this.props.res.LINGUA,
      id: id,
      guid_link: this.props.guid,
      perc: this.state.percSize,
      arrFuel: arrFuel,
      config: {
        checkVazao: this.state.checkVazao,
        checkVolume: this.state.checkVolume,
        checkAltura: this.state.checkAltura,
        checkCliente: this.state.checkCliente,
        checkAeronave: this.state.checkAeronave,
        checkClima: this.state.checkClima,
        checkPoligono: this.state.checkPoligono,
        checkPoligonoLimpo: this.state.checkPoligonoLimpo,
        checkVelocidade: this.state.checkVelocidade,
        checkFaixa: this.state.checkFaixa,
        checkMapa: this.state.checkMapa,
        checkTrajetoria: this.state.checkTrajetoria,
        checkCoordenadas: this.state.checkCoordenadas
      },
      form: {
        ordemServico: this.state.ordemServico,
        observacoes: this.state.observacoes,
        nomePiloto: this.state.nomePiloto,
        alturaCultura: this.state.alturaCultura,
        prefixoAeronave: this.state.aeronavePrefixT,
        modeloAeronave: (aircraftbrand && aircraftbrand.length > 0 && aircraftmodel && aircraftmodel.length > 0) ? `${aircraftbrand[0].name} - ${aircraftmodel[0].name}` : '',
        climate: {
          first: {
            windspeed: !isNaN(this.state.windSpeedFirst) ? this.state.windSpeedFirst : parseInt(this.state.windSpeedFirst.replace('km/h', '')),
            windheading: !isNaN(this.state.windHeadingFirst) ? this.state.windHeadingFirst : parseInt(this.state.windHeadingFirst.replace('°', '')),
            temperature: !isNaN(this.state.temperatureFirst) ? this.state.temperatureFirst : parseInt(this.state.temperatureFirst.replace('°C', '')),
            airrh: !isNaN(this.state.airRHFirst) ? this.state.airRHFirst : parseInt(this.state.airRHFirst.replace('%', ''))
          },
          last: {
            windspeed: !isNaN(this.state.windSpeedLast) ? this.state.windSpeedLast : parseInt(this.state.windSpeedLast.replace('km/h', '')),
            windheading: !isNaN(this.state.windHeadingLast) ? this.state.windHeadingLast : parseInt(this.state.windHeadingLast.replace('°', '')),
            temperature: !isNaN(this.state.temperatureLast) ? this.state.temperatureLast : parseInt(this.state.temperatureLast.replace('°C', '')),
            airrh: !isNaN(this.state.airRHLast) ? this.state.airRHLast : parseInt(this.state.airRHLast.replace('%', ''))
          }
        }
      },
      weatherData: this.state.weatherData,
      windSpeedUnit: this.state.windSpeedUnit,
      checkResumo: this.state.checkResumo,
      checkResumoDetalhado: this.state.checkResumoDetalhado,
      checkResumoTitulo: this.state.checkResumoTitulo,
      checkResumoCliente: this.state.checkResumoCliente,
      checkResumoPropriedade: this.state.checkResumoPropriedade,
      checkResumoArea: this.state.checkResumoArea,
      checkResumoFaixa: this.state.checkResumoFaixa,
      checkResumoVazao: this.state.checkResumoVazao,
      checkResumoInicio: this.state.checkResumoInicio,
      checkResumoFim: this.state.checkResumoFim,
      checkResumoAeronave: this.state.checkResumoAeronave,
      checkResumoPiloto: this.state.checkResumoPiloto,
      checkResumoTalhoes: this.state.checkResumoTalhoes,
      checkResumoLatLng: this.state.checkResumoLatLng,
      checkResumoAlturaCultura: this.state.checkResumoAlturaCultura,
      property: this.state.selectedProperty,
      otherProperty: this.state.customPropertyName,
      titulo: this.state.titulo,
      cliente: this.state.cliente,
      areaTotalAplicada: this.state.areaTotalAplicada,
      inicioAplicacao: this.state.inicioAplicacao,
      fimAplicacao: this.state.fimAplicacao,
      talhoes: this.state.talhoes,
    };

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.blob();
      })
      .then(
        (result) => {
          this.setState({ progress: false });
          const fileName = this.state.title_sk ? this.state.title_sk : this.state.title
            .replace("/", "-")
            .replace("\\", "-")
            .replace(":", "-")
            .replace(".", "-")
            .replace("!", "-");

          if (result.type === 'application/pdf' && result.size > 0) {
            saveAs(result, `${fileName}-APL.pdf`);
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
          // if (this.state.checkResumo) {
          this.saveOperationalReport();
          // }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  saveOperationalReport = () => {
    const {
      id_report,
      id,
      titulo,
      cliente,
      customPropertyName,
      selectedProperty,
      areaTotalAplicada,
      inicioAplicacao,
      fimAplicacao,
      aeronavePrefixT,
      nomePiloto,
      talhoes,
      alturaCultura
    } = this.state;

    let apiUrl = Config.server + '/report_operational';
    let method = '';

    const formData = new URLSearchParams();

    if (id_report) {
      apiUrl += `/${id_report}`;
      method = 'PUT';
    } else {
      method = 'POST';
    }

    formData.append('id_job', id);
    formData.append('title', titulo);
    formData.append('client', cliente);
    formData.append('property', selectedProperty);
    formData.append('customPropertyName', customPropertyName || '');
    formData.append('area', areaTotalAplicada);
    formData.append('startDate', this.convertToLocalDateTimeString(inicioAplicacao));
    formData.append('endDate', this.convertToLocalDateTimeString(fimAplicacao));
    formData.append('plane', aeronavePrefixT || '');
    formData.append('pilot', nomePiloto || '');
    formData.append('heightCulture', alturaCultura || '');
    formData.append('polygonData', JSON.stringify(talhoes));

    const options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then(
        (result) => {
          if (result && result.error) {
            notification.open({
              message: this.props.res[result.message],
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          } else {
            let msg = id_report
              ? this.props.res.ITEM_ALTERADO
              : this.props.res.ITEM_INCLUIR;
            notification.open({
              message: this.props.res.SUCESSO,
              description: msg,
              icon: <MaterialIcon icon="check_circle" className="text-success" />,
            });
          }
          this.readReportOperational(id)
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          }
        }
      );
  };

  getFileName = (title = this.state.title) => {
    return String(title).replace(/[\\/:.!]/g, '-');
  };

  downloadKMZOrJSON = (id, tipo = null) => {
    let data = {
      culture: this.props.res.LINGUA,
      id: id,
      titulo: this.state.titulo,
      cliente: this.state.cliente,
      talhoes: this.state.talhoes,
      config: {
        checkVazao: this.state.checkVazao,
        checkVolume: this.state.checkVolume,
        checkAltura: this.state.checkAltura,
        checkCliente: this.state.checkCliente,
        checkAeronave: this.state.checkAeronave,
        checkClima: this.state.checkClima,
        checkPoligono: this.state.checkPoligono,
        checkPoligonoLimpo: this.state.checkPoligonoLimpo,
        checkVelocidade: this.state.checkVelocidade,
        checkFaixa: this.state.checkFaixa,
        checkOnOff: this.state.checkOnOff,
        checkRumo: this.state.checkRumo,
        checkTrajetoria: this.state.checkTrajetoria,
        checkEstenderTiro: this.state.checkEstenderTiro
      }
    };

    let apiUrl = Config.server + '/reljson';
    const method = 'POST';

    if (tipo === ".kmz") {
      apiUrl = Config.server + '/relkmz';
    } else if (tipo === ".shape") {
      apiUrl = Config.server + '/relshape';
    }

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.blob();
      })
      .then(
        (result) => {
          this.setState({ progress: false });

          let fileExtension = tipo === '.kmz' ? '.kmz' : tipo === '.shape' ? '.zip' : '.json';
          let fileTitle = tipo === '.shape' && this.state.titulo ? this.state.titulo : this.state.title;
          let file_name = `${this.getFileName(fileTitle)}${fileExtension}`;
          saveAs(result, file_name);
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  openModal = (report) => {
    this.setState({
      open: !this.state.open,
      next: report,
      fileFormat: report === "KMZ" ? 'kmz' : this.state.fileFormat
    });
  };

  runNext = () => {
    switch (this.state.next) {
      case "APL":
        this.downloadRA(this.state.id, this.state.arrFuel);
        break;
      case "JSON":
        this.downloadKMZOrJSON(this.state.task, ".json");
        break;
      case "KMZ":
        this.downloadKMZOrJSON(this.state.task, this.state.fileFormat === 'shape' ? ".shape" : ".kmz");
        break;
      default:
        break;
    }

    this.setState({ open: false });
  };

  maskedTemperature = (props) => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, '°C']}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  };

  maskedHeading = (props) => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, /\d/, '°']}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  };

  maskedSpeed = (props) => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, 'km/h']}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  };

  maskedPercent = (props) => {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, /\d/, '%']}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  };

  listStations = () => {
    const apiUrl = `${Config.server}/weather_source`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then(
        (result) => {
          this.setState({
            stations: result,
          });
        },
        (error) => {
          console.error(error);
        }
      );
  };

  goToCoordinates = (lat, lng) => {
    this.mymap.setView([lat, lng]);
  };

  renderClimateData = (guid, lat, lng) => {
    const { res } = this.props;
    const { weatherData = [], stations = [], windSpeedUnit, poligonos = [] } = this.state;
    const isEditing = this.state.editingGuid === guid;

    const polygon = weatherData.find(data => data.guid === guid);
    const { startData = [], endData = [], selectedIdSource } = polygon || {};
    const startDataArray = Array.isArray(startData) ? startData : startData ? [startData] : [];
    const endDataArray = Array.isArray(endData) ? endData : endData ? [endData] : [];
    const hasData = startDataArray.length > 0 || endDataArray.length > 0;

    const availableStationIds = [...new Set(
      [...startDataArray, ...endDataArray]
        .map(s => s && s.id_source)
        .filter(id => id !== undefined && id !== null)
    )];

    const hasStationSource = availableStationIds.length > 0;

    const selectedSource =
      selectedIdSource !== undefined && selectedIdSource !== null
        ? selectedIdSource
        : (hasStationSource ? availableStationIds[0] : null);

    let dataStart = {};
    let dataEnd = {};

    if (hasStationSource && selectedSource !== null) {
      dataStart = startDataArray.find(data => data && data.id_source === selectedSource) || {};
      dataEnd = endDataArray.find(data => data && data.id_source === selectedSource) || {};
    } else {
      dataStart = startDataArray[0] || {};
      dataEnd = endDataArray[0] || {};
    }

    const selectedStation =
      selectedSource !== null && selectedSource !== undefined
        ? stations.find(s => s.id === selectedSource)
        : null;

    const stationName = hasStationSource
      ? (selectedStation?.name || `${res.ESTACAO} ${selectedSource}`)
      : (hasData ? (res.ESTACAO_MANUAL || 'Manual') : '-');

    const canEdit = !!(polygon && polygon.id_job);

    const effectiveLat = lat || polygon?.lat;
    const effectiveLng = lng || polygon?.lng;

    const isManualStart = dataStart && (dataStart.id_source === null || dataStart.id_source === undefined);
    const isManualEnd = dataEnd && (dataEnd.id_source === null || dataEnd.id_source === undefined);

    const polygonOriginal = poligonos.find(p => p.guid === guid) || {};
    const startDateMs = polygonOriginal.time_ini || null;
    const endDateMs = polygonOriginal.time_fim || null;

    const formatDateTimeLocal = (value) => {
      if (!value) return '';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => n.toString().padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const startInputValue = dataStart.datetime
      ? formatDateTimeLocal(dataStart.datetime)
      : (startDateMs ? formatDateTimeLocal(startDateMs) : '');

    const endInputValue = dataEnd.datetime
      ? formatDateTimeLocal(dataEnd.datetime)
      : (endDateMs ? formatDateTimeLocal(endDateMs) : '');

    const startDisplay =
      dataStart.datetime
        ? `${new Date(dataStart.datetime).toLocaleDateString()} ${new Date(dataStart.datetime).toLocaleTimeString()}`
        : (startDateMs
          ? `${new Date(startDateMs).toLocaleDateString()} ${new Date(startDateMs).toLocaleTimeString()}`
          : null);

    const endDisplay =
      dataEnd.datetime
        ? `${new Date(dataEnd.datetime).toLocaleDateString()} ${new Date(dataEnd.datetime).toLocaleTimeString()}`
        : (endDateMs
          ? `${new Date(endDateMs).toLocaleDateString()} ${new Date(endDateMs).toLocaleTimeString()}`
          : null);

    return (
      <>
        <TableRow>
          <TableCell align="left">
            <Button
              variant="contained"
              color={isEditing ? 'success' : 'primary'}
              onClick={async () => {
                if (isEditing) {
                  const polygonData = (this.state.weatherData || []).find(data => data.guid === guid);
                  if (polygonData) {
                    await this.savePolygonClimateData(polygonData);
                    notification.open({
                      message: res.SUCESSO,
                      description: res.DADOS_CLIMATICOS_SALVOS,
                      icon: <MaterialIcon icon="check_circle" className="text-success" />,
                    });
                  }
                  this.setState({ editingGuid: null });
                } else {
                  const polygonData = (this.state.weatherData || []).find(data => data.guid === guid);
                  if (polygonData) {
                    const { id_job, guid: polygonGuid, startData, endData, lat: plat, lng: plng } = polygonData;

                    const polygonReq = {
                      guid: polygonGuid,
                      time_ini: startData?.[0]?.startDateApplication || startDateMs || null,
                      time_fim: endData?.[0]?.endDateApplication || endDateMs || null,
                      poly: {
                        geometry: {
                          coordinates: [[[parseFloat(plng || effectiveLng), parseFloat(plat || effectiveLat)]]],
                        },
                      },
                    };

                    if (
                      id_job &&
                      polygonReq.time_ini &&
                      polygonReq.time_fim &&
                      polygonReq.poly.geometry.coordinates[0][0][0] &&
                      polygonReq.poly.geometry.coordinates[0][0][1]
                    ) {
                      try {
                        await this.listWeatherDataByLocation([polygonReq], id_job);
                      } catch (error) {
                        console.error(error);
                      }
                    }
                  }

                  this.setState({ editingGuid: guid });
                }
              }}
              disabled={!canEdit}
            >
              {isEditing ? res.SALVAR : res.EDITAR}
            </Button>
          </TableCell>

          <TableCell align="right">
            {isEditing && hasStationSource ? (
              <Select
                value={
                  selectedSource !== null && selectedSource !== undefined
                    ? selectedSource
                    : ''
                }
                onChange={(e) => {
                  const newSource = parseInt(e.target.value, 10);
                  const newStart = startDataArray.find(data => data && data.id_source === newSource) || {};
                  const newEnd = endDataArray.find(data => data && data.id_source === newSource) || {};
                  const newLat = newStart.lat ?? newEnd.lat ?? effectiveLat;
                  const newLng = newStart.lng ?? newEnd.lng ?? effectiveLng;

                  this.removeStationMarker();
                  if (newLat && newLng) {
                    this.addStationImage(newLat, newLng);
                  }

                  this.setState(prev => ({
                    weatherData: (prev.weatherData || []).map(data =>
                      data.guid === guid ? { ...data, selectedIdSource: newSource } : data
                    )
                  }));
                }}
              >
                {availableStationIds.map(id => {
                  const stationsData = stations.find(station => station.id === id);
                  return (
                    <MenuItem key={id} value={id}>
                      {stationsData?.name || `Estação ${id}`}
                    </MenuItem>
                  );
                })}
              </Select>
            ) : (
              <span style={{ whiteSpace: 'nowrap', marginLeft: '6rem' }}>{stationName}</span>
            )}
          </TableCell>
          <TableCell align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.goToCoordinates(effectiveLat, effectiveLng)}
              disabled={!effectiveLat || !effectiveLng}
              title="Localizar polígono"
            >
              <GpsFixedIcon />
            </Button>
          </TableCell>
        </TableRow>

        {/* Data */}
        {this.item_title(res.DATA)}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={startInputValue}
                onChange={(e) =>
                  this.handleEditChange('datetime', e.target.value, 'start', dataStart.id_source)
                }
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            ) : (
              startDisplay || '-'
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={endInputValue}
                onChange={(e) =>
                  this.handleEditChange('datetime', e.target.value, 'end', dataEnd.id_source)
                }
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            ) : (
              endDisplay || '-'
            )}
          </TableCell>
        </TableRow>

        {/* Temperatura */}
        {this.item_title(tools.replaceString(res._TEMPERATURA_UNI, res.LINGUA === 'en-US' ? res.F : res.C))}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataStart.air_temperature ?? ''}
                onChange={(e) =>
                  this.handleEditChange('air_temperature', e.target.value, 'start', dataStart.id_source)
                }
                type="number"
                label="Inicial"
                fullWidth
              />
            ) : (
              dataStart.air_temperature != null ?
                (res.LINGUA === 'en-US' ? tools.c_to_f(Number(dataStart.air_temperature)).toFixed(1) : Number(dataStart.air_temperature).toFixed(1)) :
                '-'
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataEnd.air_temperature ?? ''}
                onChange={(e) =>
                  this.handleEditChange('air_temperature', e.target.value, 'end', dataEnd.id_source)
                }
                type="number"
                label="Final"
                fullWidth
              />
            ) : (
              dataEnd.air_temperature != null ?
                (res.LINGUA === 'en-US' ? tools.c_to_f(Number(dataEnd.air_temperature)).toFixed(1) : Number(dataEnd.air_temperature).toFixed(1)) :
                '-'
            )}
          </TableCell>
        </TableRow>

        {/* Umidade */}
        {this.item_title(res.HUMIDADE_UNI)}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataStart.air_humidity ?? ''}
                onChange={(e) =>
                  this.handleEditChange('air_humidity', e.target.value, 'start', dataStart.id_source)
                }
                type="number"
                label="Inicial"
                fullWidth
              />
            ) : (
              dataStart.air_humidity != null ? Number(dataStart.air_humidity).toFixed(1) : '-'
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataEnd.air_humidity ?? ''}
                onChange={(e) =>
                  this.handleEditChange('air_humidity', e.target.value, 'end', dataEnd.id_source)
                }
                type="number"
                label="Final"
                fullWidth
              />
            ) : (
              dataEnd.air_humidity != null ? Number(dataEnd.air_humidity).toFixed(1) : '-'
            )}
          </TableCell>
        </TableRow>

        {/* Velocidade do Vento */}
        {this.item_title(tools.replaceString(res._VELOCIDADE_VENTO, windSpeedUnit))}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataStart.wind_speed ?? ''}
                onChange={(e) =>
                  this.handleEditChange('wind_speed', e.target.value, 'start', dataStart.id_source)
                }
                type="number"
                label="Inicial"
                fullWidth
              />
            ) : (
              dataStart.wind_speed !== '-' && dataStart.wind_speed != null
                ? (isManualStart
                  ? Number(dataStart.wind_speed).toFixed(1)
                  : this.convertWindSpeed(dataStart.wind_speed, windSpeedUnit))
                : '-'
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataEnd.wind_speed ?? ''}
                onChange={(e) =>
                  this.handleEditChange('wind_speed', e.target.value, 'end', dataEnd.id_source)
                }
                type="number"
                label="Final"
                fullWidth
              />
            ) : (
              dataEnd.wind_speed !== '-' && dataEnd.wind_speed != null
                ? (isManualEnd
                  ? Number(dataEnd.wind_speed).toFixed(1)
                  : this.convertWindSpeed(dataEnd.wind_speed, windSpeedUnit))
                : '-'
            )}
          </TableCell>
        </TableRow>

        {/* Direção do Vento */}
        {this.item_title(res.DIRECAO_VENTO_UNI)}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataStart.wind_direction ?? ''}
                onChange={(e) =>
                  this.handleEditChange('wind_direction', e.target.value, 'start', dataStart.id_source)
                }
                type="number"
                label="Inicial"
                fullWidth
              />
            ) : (
              dataStart.wind_direction != null && dataStart.wind_direction !== '-' ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                  <div
                    style={{
                      position: 'relative',
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      border: '2px solid gray',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div style={{ position: 'absolute', top: '-4px', fontWeight: 'bold' }}>N</div>
                    <div style={{ position: 'absolute', bottom: '-4px', fontWeight: 'bold' }}>S</div>
                    <div style={{ position: 'absolute', right: '2px', fontWeight: 'bold' }}>L</div>
                    <div style={{ position: 'absolute', left: '2px', fontWeight: 'bold' }}>O</div>
                    <img
                      src={windArrowImage}
                      alt="Direção do vento"
                      style={{
                        transform: `rotate(${parseFloat(dataStart.wind_direction) + 180}deg)`,
                        width: '20px',
                        height: '20px'
                      }}
                    />
                  </div>
                  <span style={{ marginLeft: '0.25rem' }}>
                    {dataStart.wind_direction}°
                  </span>
                </div>
              ) : (
                <span>-</span>
              )
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataEnd.wind_direction ?? ''}
                onChange={(e) =>
                  this.handleEditChange('wind_direction', e.target.value, 'end', dataEnd.id_source)
                }
                type="number"
                label="Final"
                fullWidth
              />
            ) : (
              dataEnd.wind_direction != null && dataEnd.wind_direction !== '-' ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                  <div
                    style={{
                      position: 'relative',
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      border: '2px solid gray',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div style={{ position: 'absolute', top: '-4px', fontWeight: 'bold' }}>N</div>
                    <div style={{ position: 'absolute', bottom: '-4px', fontWeight: 'bold' }}>S</div>
                    <div style={{ position: 'absolute', right: '2px', fontWeight: 'bold' }}>L</div>
                    <div style={{ position: 'absolute', left: '2px', fontWeight: 'bold' }}>O</div>
                    <img
                      src={windArrowImage}
                      alt="Direção do vento"
                      style={{
                        transform: `rotate(${parseFloat(dataEnd.wind_direction) + 180}deg)`,
                        width: '20px',
                        height: '20px'
                      }}
                    />
                  </div>
                  <span style={{ marginLeft: '0.25rem' }}>
                    {dataEnd.wind_direction}°
                  </span>
                </div>
              ) : (
                <span>-</span>
              )
            )}
          </TableCell>
        </TableRow>

        {/* Pressão */}
        {this.item_title(res.PRESSAO_UNI)}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataStart.pressure ?? ''}
                onChange={(e) =>
                  this.handleEditChange('pressure', e.target.value, 'start', dataStart.id_source)
                }
                type="number"
                label="Inicial"
                fullWidth
              />
            ) : (
              <span>{dataStart.pressure != null ? Number(dataStart.pressure).toFixed(1) : '-'}</span>
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataEnd.pressure ?? ''}
                onChange={(e) =>
                  this.handleEditChange('pressure', e.target.value, 'end', dataEnd.id_source)
                }
                type="number"
                label="Final"
                fullWidth
              />
            ) : (
              <span>{dataEnd.pressure != null ? Number(dataEnd.pressure).toFixed(1) : '-'}</span>
            )}
          </TableCell>
        </TableRow>

        {/* Delta-T */}
        {this.item_title(res.DELTA_T)}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataStart.delta_t ?? ''}
                onChange={(e) =>
                  this.handleEditChange('delta_t', e.target.value, 'start', dataStart.id_source)
                }
                type="number"
                label="Inicial"
                fullWidth
              />
            ) : (
              <>
                <span>
                  {dataStart.delta_t != null ? Number(dataStart.delta_t).toFixed(1) : '-'}
                </span>
                {dataStart.delta_t != null && (
                  <Tooltip
                    title={
                      <div
                        style={{
                          backgroundColor: '#fff',
                          padding: '10px',
                          borderRadius: '4px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          width: '22.5rem'
                        }}
                      >
                        <DeltaTHeat
                          atual={dataStart.delta_t}
                          humidade={dataStart.air_humidity}
                          temperatura={dataStart.air_temperature}
                          res={res}
                        />
                      </div>
                    }
                    placement="top"
                    arrow
                    classes={{ tooltip: this.props.classes.customWidthTooltip }}
                  >
                    <HelpOutlineIcon
                      style={{
                        color: 'rgb(250, 125, 52)',
                        marginBottom: '0',
                        width: '1.25rem',
                        marginLeft: '0.5rem',
                        cursor: 'pointer'
                      }}
                    />
                  </Tooltip>
                )}
              </>
            )}
          </TableCell>
          <TableCell align="right">
            {isEditing ? (
              <TextField
                value={dataEnd.delta_t ?? ''}
                onChange={(e) =>
                  this.handleEditChange('delta_t', e.target.value, 'end', dataEnd.id_source)
                }
                type="number"
                label="Final"
                fullWidth
              />
            ) : (
              <>
                <span>
                  {dataEnd.delta_t != null ? Number(dataEnd.delta_t).toFixed(1) : '-'}
                </span>
                {dataEnd.delta_t != null && (
                  <Tooltip
                    title={
                      <div
                        style={{
                          backgroundColor: '#fff',
                          padding: '10px',
                          borderRadius: '4px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          width: '22.5rem'
                        }}
                      >
                        <DeltaTHeat
                          atual={dataEnd.delta_t}
                          humidade={dataEnd.air_humidity}
                          temperatura={dataEnd.air_temperature}
                          res={res}
                        />
                      </div>
                    }
                    placement="top"
                    arrow
                    classes={{ tooltip: this.props.classes.customWidthTooltip }}
                  >
                    <HelpOutlineIcon
                      style={{
                        color: 'rgb(250, 125, 52)',
                        marginBottom: '0',
                        width: '1.25rem',
                        marginLeft: '0.5rem',
                        cursor: 'pointer'
                      }}
                    />
                  </Tooltip>
                )}
              </>
            )}
          </TableCell>
        </TableRow>

        {/* Inversão Térmica */}
        {this.item_title(res.INVERSAO_TERMICA)}
        <TableRow>
          <TableCell></TableCell>
          <TableCell align="right">
            <span>{dataStart.thermalInversion || '-'}</span>
            {dataStart.thermalInversion && (
              <Tooltip
                title={
                  <div
                    style={{
                      backgroundColor: '#fff',
                      padding: '10px',
                      borderRadius: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      width: '25.25rem'
                    }}
                  >
                    {dataStart.thermalInversion === "Não está ocorrendo inversão térmica" || dataStart.thermalInversion === "Desabilitado" ? (
                      <img
                        style={{ marginTop: '2.5rem', maxHeight: '12rem', borderRadius: '1rem' }}
                        src={normalFlowExample}
                        alt={res.FLUXO_NORMAL}
                      />
                    ) : (
                      <img
                        style={{ marginTop: '2.5rem', maxHeight: '12rem', borderRadius: '1rem' }}
                        src={thermalInversionExample}
                        alt={res.FLUXO_INVERSAO_TERMICA}
                      />
                    )}
                  </div>
                }
                placement="top"
                arrow
                classes={{ tooltip: this.props.classes.customWidthTooltip }}
              >
                <HelpOutlineIcon
                  style={{
                    color: 'rgb(250, 125, 52)',
                    marginBottom: '0',
                    width: '1.25rem',
                    marginLeft: '0.5rem',
                    cursor: 'pointer'
                  }}
                />
              </Tooltip>
            )}
          </TableCell>
          <TableCell align="right">
            <span>{dataEnd.thermalInversion || '-'}</span>
            {dataEnd.thermalInversion && (
              <Tooltip
                title={
                  <div
                    style={{
                      backgroundColor: '#fff',
                      padding: '10px',
                      borderRadius: '4px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                      width: '25.25rem'
                    }}
                  >
                    {dataEnd.thermalInversion === "Não está ocorrendo inversão térmica" || dataEnd.thermalInversion === "Desabilitado" ? (
                      <img
                        style={{ marginTop: '2.5rem', maxHeight: '12rem', borderRadius: '1rem' }}
                        src={normalFlowExample}
                        alt={res.FLUXO_NORMAL}
                      />
                    ) : (
                      <img
                        style={{ marginTop: '2.5rem', maxHeight: '12rem', borderRadius: '1rem' }}
                        src={thermalInversionExample}
                        alt={res.FLUXO_INVERSAO_TERMICA}
                      />
                    )}
                  </div>
                }
                placement="top"
                arrow
                classes={{ tooltip: this.props.classes.customWidthTooltip }}
              >
                <HelpOutlineIcon
                  style={{
                    color: 'rgb(250, 125, 52)',
                    marginBottom: '0',
                    width: '1.25rem',
                    marginLeft: '0.5rem',
                    cursor: 'pointer'
                  }}
                />
              </Tooltip>
            )}
          </TableCell>
        </TableRow>

        {/* Separador */}
        <TableRow>
          <TableCell colSpan={3} style={{ backgroundColor: '#ccc' }}></TableCell>
        </TableRow>
      </>
    );
  };

  handleEditChange = (field, value, dataType, id_source) => {
    this.setState((prevState) => {
      const editingGuid = prevState.editingGuid;
      if (!editingGuid) return null;

      const normalizedValue = value === '' ? null : value;

      const normalizeArray = (data) =>
        Array.isArray(data) ? data : (data ? [data] : []);

      const updatedWeatherData = (prevState.weatherData || []).map((polygon) => {
        if (polygon.guid !== editingGuid) return polygon;

        let startData = normalizeArray(polygon.startData);
        let endData = normalizeArray(polygon.endData);

        const applyChange = (array, targetType) => {
          if (dataType !== targetType) return array;

          // define qual id_source usar:
          // - se veio no parâmetro, usa;
          // - senão, se já existe item, usa o id_source dele;
          // - senão, será NULL (manual).
          let sourceToUse;

          if (id_source !== undefined && id_source !== null) {
            sourceToUse = id_source;
          } else if (array.length > 0 && array[0].id_source !== undefined) {
            sourceToUse = array[0].id_source;
          } else {
            sourceToUse = null;
          }

          let updated = false;

          const newArray = array.map((item) => {
            const itemSource = item.id_source !== undefined ? item.id_source : null;
            if (itemSource === sourceToUse) {
              updated = true;
              return {
                ...item,
                [field]: normalizedValue,
              };
            }
            return item;
          });

          if (!updated) {
            const newItem = {
              id_source: sourceToUse,
              [field]: normalizedValue,
            };
            newArray.push(newItem);
          }

          return newArray;
        };

        startData = applyChange(startData, 'start');
        endData = applyChange(endData, 'end');

        return {
          ...polygon,
          startData,
          endData,
        };
      });

      return { weatherData: updatedWeatherData };
    });
  };

  toggleWindSpeedUnit = () => {
    this.setState(prevState => {
      const companyUnit = Units.getSpeedUnit(this.props.res);
      const newUnit = prevState.windSpeedUnit === 'm/s' ? companyUnit : 'm/s';
      localStorage.setItem('windSpeedUnit', newUnit);

      return {
        windSpeedUnit: newUnit,
      };
    });
  };

  convertWindSpeed = (value, targetUnit) => {
    if (isNaN(value)) return '-';

    if (targetUnit === 'fps' || targetUnit === 'ft/s') {
      return tools.mps_to_fts(value).toFixed(1);
    }
    return Units.formatValue(Units.convertSpeedTo(value, 'm/s', targetUnit), this.props.res);
  };

  readJob = (id) => {
    const apiUrl = Config.server + `/job/${id}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          //this.setState({ dtIni: new Date(result[0].created_gps), inicioAplicacao: new Date(result[0].created_gps) });
          this.setState({ inicioAplicacao: new Date(result[0].created_gps) });
          const validClient = result.find((item) => item.id_client !== null);
          if (validClient && validClient.id_client) {
            this.listProperties(validClient.id_client);
          }
          this.setState({
            job_guid_b: result[0].guid,
            serviceOrderID: result[0].id_service_order,
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          }
        }
      );
  };

  readReportOperational = (id_job) => {
    const apiUrl = Config.server + `/report_operational/${id_job}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      },
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result.length > 0) {
            this.setState({
              id_report: result[0].id,
              id: result[0].id_job,
              titulo: result[0].title,
              cliente: result[0].client,
              selectedProperty: result[0].property,
              isCustomProperty: result[0].property === 'Outro',
              customPropertyName: result[0].customPropertyName,
              areaTotalAplicada: result[0].area,
              // inicioAplicacao: new Date(result[0].startDate).toISOString().slice(0, 16),
              // fimAplicacao: new Date(result[0].endDate).toISOString().slice(0, 16),
              aeronavePrefixT: result[0].plane,
              nomePiloto: result[0].pilot,
              alturaCultura: result[0].heightCulture,
              polygonData: JSON.parse(result[0].polygonData),
            });
          } else {
            this.setState({ id_report: '' });
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          }
        }
      );
  };

  listProperties = (id_client) => {
    const apiUrl = `${Config.server}/allProperty/${id_client}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      },
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            properties: result.length > 0 ? result : [],
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />,
            });
          }
        }
      );
  };

  changeSize = (value) => {
    this.setState({ percSize: this.state.percSize + value });
  };

  runPerc = async () => {
    this.setState({ showPerc: false });

    let guid = this.state.job_guid ? this.state.job_guid : this.state.job_guid_b ? this.state.job_guid_b : this.props.guid;
    let data = {
      guid,
      perc: this.state.percSize,
    };

    let apiUrl = Config.server + '/job_reload';
    const method = 'POST';

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.loadTask(true);
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  convertToLocalDateTimeString = (date) => {
    return tools.dateTimeZoneFormat(date, 'YYYY-MM-DDTHH:mm', this.props.res.timezone);
  };

  getProfileAuto = () => {
    const apiUrl = Config.server + '/profile_auto_application';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          const resumo_config = result?.[0]?.aplicacao?.[0]?.resumo_config
            ? JSON.parse(result[0].aplicacao[0].resumo_config)
            : null;
          const estenderTiroEnabled = resumo_config?.checkEstenderTiro === true;

          this.setState({
            checkResumoTitulo: resumo_config ? !!resumo_config.checkResumoTitulo : true,
            checkResumoCliente: resumo_config ? !!resumo_config.checkResumoCliente : true,
            checkResumoPropriedade: resumo_config ? !!resumo_config.checkResumoPropriedade : true,
            checkResumoArea: resumo_config ? !!resumo_config.checkResumoArea : true,
            checkResumoFaixa: resumo_config ? !!resumo_config.checkResumoFaixa : true,
            checkResumoVazao: resumo_config ? !!resumo_config.checkResumoVazao : true,
            checkResumoInicio: resumo_config ? !!resumo_config.checkResumoInicio : true,
            checkResumoFim: resumo_config ? !!resumo_config.checkResumoFim : true,
            checkResumoAeronave: resumo_config ? !!resumo_config.checkResumoAeronave : true,
            checkResumoPiloto: resumo_config ? !!resumo_config.checkResumoPiloto : true,
            checkResumoTalhoes: resumo_config ? !!resumo_config.checkResumoTalhoes : true,
            checkResumoLatLng: resumo_config ? !!resumo_config.checkResumoLatLng : true,
            checkResumoAlturaCultura: resumo_config ? !!resumo_config.checkResumoAlturaCultura : true,
            checkTrajetoria: resumo_config ? !!resumo_config.checkTrajetoria : true,
            checkPoligono: resumo_config ? !!resumo_config.checkPoligono : true,
            checkPoligonoLimpo: resumo_config ? !!resumo_config.checkPoligonoLimpo : true,
            checkMapa: resumo_config ? !!resumo_config.checkMapa : true,
            checkCoordenadas: resumo_config ? !!resumo_config.checkCoordenadas : true,
            checkVazao: resumo_config ? !!resumo_config.checkVazao : true,
            checkVolume: resumo_config ? !!resumo_config.checkVolume : true,
            checkAltura: resumo_config ? !!resumo_config.checkAltura : true,
            checkCliente: resumo_config ? !!resumo_config.checkCliente : true,
            checkAeronave: resumo_config ? !!resumo_config.checkAeronave : true,
            checkClima: resumo_config ? !!resumo_config.checkClima : true,
            checkVelocidade: resumo_config ? !!resumo_config.checkVelocidade : true,
            checkFaixa: resumo_config ? !!resumo_config.checkFaixa : true,
            checkEstenderTiro: estenderTiroEnabled,
            showEstenderTiro: estenderTiroEnabled,
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  handleBackToServiceOrder = () => {
    if (!this.state.serviceOrderID) return;
    this.props.link(`/app/ordem-servico/edit/${this.state.serviceOrderID}`);
  };

  loadAircraftBrands = () => {
    const apiUrl = Config.server + '/domain/AIRCRAFTBRAND';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            aircraftbrands: result
          });

          return result;
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }

          return [];
        }
      );
  }

  loadAircraftModels = (idAircraftBrand) => {
    const apiUrl = `${Config.server}/domain/AIRCRAFTMODEL/${idAircraftBrand}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            aircraftmodels: result
          });

          return result;
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }

          this.setState({
            aircraftmodels: []
          });

          return [];
        }
      );
  }

  render() {
    const { res, classes } = this.props;

    return (
      <div className="rowMapCO maxVHMap">
        <Dialog open={this.state.open} onClose={event => this.setState({ open: false })} >
          <DialogTitle id="customized-dialog-title">
            {res.CONFIGURACOES_RELATORIO}
          </DialogTitle>

          <DialogContent>
            {this.state.next === "KMZ" &&
              <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.5rem 0' }}>
                <span>Formato:</span>
                <Button
                  variant={this.state.fileFormat === 'kmz' ? 'contained' : 'outlined'}
                  color="primary"
                  onClick={() => this.setState({ fileFormat: 'kmz' })}
                >
                  KMZ
                </Button>
                <Button
                  variant={this.state.fileFormat === 'shape' ? 'contained' : 'outlined'}
                  color="primary"
                  onClick={() => this.setState({ fileFormat: 'shape' })}
                >
                  SHAPE
                </Button>
              </div>
            }
            {this.state.next === "APL" && <>
              <FormControl style={{ width: '95%' }}><InputLabel>{res.ORDEM_SERVICO}</InputLabel><Input value={this.state.ordemServico} onChange={this.handleChange('ordemServico')} /></FormControl>
              <FormControl style={{ width: '95%', marginTop: '1rem' }}><InputLabel>{res.OBSERVACOES}</InputLabel><Input value={this.state.observacoes} onChange={this.handleChange('observacoes')} /></FormControl>
              <FormControl style={{ width: '40%', marginTop: '1rem', marginRight: '5rem' }}><InputLabel>{res.NOME_PILOTO}</InputLabel><Input value={this.state.nomePiloto} onChange={this.handleChange('nomePiloto')} /></FormControl>
              <FormControl style={{ width: '40%', marginTop: '1rem' }}><InputLabel>{res.PREFIXO_AERONAVE}</InputLabel><Input value={this.state.aeronavePrefixT} onChange={this.handleChange('aeronavePrefixT')} /></FormControl>
              <FormControl style={{ width: '40%', marginTop: '1rem', marginRight: '5rem' }}>
                <InputLabel htmlFor="aircraftbrand">{res.FABRICANTE}</InputLabel>
                <Select
                  style={{ textAlign: 'left' }}
                  id='aircraftbrand'
                  value={this.state.id_aircraftbrand || 0}
                  onChange={this.handleAircraftBrandChange}
                  inputProps={{
                    id: 'id_aircraftbrand',
                  }}
                >
                  <MenuItem key={'0id_aircraftbrand'} value={0}>{res.SELECIONE}</MenuItem>
                  {this.state.aircraftbrands.map((n, key) => {
                    return (
                      <MenuItem key={key} value={Number(n.id)}>{n.name}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <FormControl style={{ width: '40%', marginTop: '1rem' }}>
                <InputLabel htmlFor="aircraftmodel">{res.MODELO}</InputLabel>
                <Select
                  style={{ textAlign: 'left' }}
                  id='aircraftmodel'
                  value={this.state.id_aircraftmodel || 0}
                  onChange={this.handleChange('id_aircraftmodel')}
                  inputProps={{
                    id: 'id_aircraftmodel',
                  }}
                >
                  <MenuItem key={'0aircraftmodel'} value={0}>{res.SELECIONE}</MenuItem>
                  {this.state.aircraftmodels.map((n, key) => {
                    return (
                      <MenuItem key={key} value={Number(n.id)}>{n.name}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl style={{ width: '40%', marginTop: '1rem', marginRight: '5rem' }}><InputLabel>{res.ALTURA_CULTURA}</InputLabel><Input value={this.state.alturaCultura} onChange={this.handleChange('alturaCultura')} /></FormControl>
            </>}

            <DialogTitle id="customized-dialog-title">{res.RELATORIO}</DialogTitle>
            <DialogContentText
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1.5rem',
              }}
            >
              <div
                style={{
                  gridColumn: 'span 2',
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-between',
                  flexDirection: 'column'
                }}
              >
                {this.state.next === "APL" && (
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumo}
                        name="checkResumo"
                        onClick={() => this.setState({ checkResumo: !this.state.checkResumo })}
                      />
                    }
                    label={res.RELATORIO_RESUMIDO}
                  />
                )}
                {this.state.checkResumo && this.state.next === "APL" && this.state.poligonos.length > 1 ?
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoDetalhado}
                        name="checkResumoDetalhado"
                        onClick={() => this.setState({ checkResumoDetalhado: !this.state.checkResumoDetalhado })}
                      />
                    }
                    label={res.INFORMACAO_DETALHADA_POLIGONO}
                  />
                  :
                  null
                }

                {this.state.checkResumo && this.state.next === "APL" && (
                  <div style={{ marginLeft: 24, marginTop: 8 }}>
                    <strong style={{ display: 'block', marginBottom: 8 }}>{res.CAMPOS_RESUMO}:</strong>

                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoTitulo}
                            onChange={() =>
                              this.setState({ checkResumoTitulo: !this.state.checkResumoTitulo })}
                          />
                        }
                        label={res.TITULO}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoCliente}
                            onChange={() =>
                              this.setState({ checkResumoCliente: !this.state.checkResumoCliente })}
                          />
                        }
                        label={res.CLIENTE}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoPropriedade}
                            onChange={() =>
                              this.setState({ checkResumoPropriedade: !this.state.checkResumoPropriedade })}
                          />
                        }
                        label={res.PROPRIEDADE}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoArea}
                            onChange={() =>
                              this.setState({ checkResumoArea: !this.state.checkResumoArea })}
                          />
                        }
                        label={res.AREA_TOTAL_APLICADA}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoFaixa}
                            onChange={() =>
                              this.setState({ checkResumoFaixa: !this.state.checkResumoFaixa })}
                          />
                        }
                        label={res.FAIXA_APP}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoVazao}
                            onChange={() =>
                              this.setState({ checkResumoVazao: !this.state.checkResumoVazao })}
                          />
                        }
                        label={res.VAZAO}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoInicio}
                            onChange={() =>
                              this.setState({ checkResumoInicio: !this.state.checkResumoInicio })}
                          />
                        }
                        label={res.INICIO}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoFim}
                            onChange={() =>
                              this.setState({ checkResumoFim: !this.state.checkResumoFim })}
                          />
                        }
                        label={res.FIM}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoAeronave}
                            onChange={() =>
                              this.setState({ checkResumoAeronave: !this.state.checkResumoAeronave })}
                          />
                        }
                        label={res.AERONAVE}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoPiloto}
                            onChange={() =>
                              this.setState({ checkResumoPiloto: !this.state.checkResumoPiloto })}
                          />
                        }
                        label={res.PILOTO}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoTalhoes}
                            onChange={() =>
                              this.setState({ checkResumoTalhoes: !this.state.checkResumoTalhoes })}
                          />
                        }
                        label={res.TALHOES_}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoLatLng}
                            onChange={() =>
                              this.setState({ checkResumoLatLng: !this.state.checkResumoLatLng })}
                          />
                        }
                        label={`${res.LATITUDE} / ${res.LONGITUDE}`}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkResumoAlturaCultura}
                            onChange={() =>
                              this.setState({ checkResumoAlturaCultura: !this.state.checkResumoAlturaCultura })}
                          />
                        }
                        label={`${res.ALTURA_CULTURA}`}
                      />
                    </FormGroup>
                  </div>
                )}
              </div>

              <TextField
                label={res.TITULO}
                fullWidth
                value={this.state.titulo || ''}
                onChange={(e) => this.setState({ titulo: e.target.value })}
              />
              <TextField
                label={res.CLIENTE}
                fullWidth
                value={this.state.cliente || ''}
                onChange={(e) => this.setState({ cliente: e.target.value })}
              />

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: this.state.isCustomProperty ? '1fr 1fr' : '1fr',
                  gap: '1.5rem',
                }}
              >
                <FormControl fullWidth>
                  <InputLabel htmlFor="select-property">{res.PROPRIEDADE}</InputLabel>
                  <Select
                    id="select-property"
                    value={this.state.selectedProperty}
                    onChange={(event) => {
                      const value = event.target.value;
                      this.setState({ selectedProperty: value, isCustomProperty: value === 'Outro' });
                    }}
                  >
                    <MenuItem key="0property" value="" disabled>
                      {res.SELECIONE_PROPRIEDADE}
                    </MenuItem>
                    {this.state.properties.map((item, index) => (
                      <MenuItem key={index} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                    <MenuItem key="other-property" value="Outro">
                      {res.OUTROTXT}
                    </MenuItem>
                  </Select>
                </FormControl>
                {this.state.isCustomProperty && (
                  <TextField
                    label={res.NOME_PROPRIEDADE}
                    fullWidth
                    value={this.state.customPropertyName || ''}
                    onChange={(event) =>
                      this.setState({ customPropertyName: event.target.value })
                    }
                  />
                )}
              </div>
              <TextField
                label="Área total aplicada (ha)"
                fullWidth
                value={this.state.areaTotalAplicada || ''}
                onChange={(e) => this.setState({ areaTotalAplicada: e.target.value })}
              />

              <TextField
                label={res.INICIO_APLICACAO}
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={this.state.inicioAplicacao ? this.convertToLocalDateTimeString(this.state.inicioAplicacao) : ''}
                onChange={(e) => {
                  const date = new Date(e.target.value);
                  this.setState({ inicioAplicacao: date });
                }}
              />
              <TextField
                label={res.FIM_APLICACAO}
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={this.state.fimAplicacao ? this.convertToLocalDateTimeString(this.state.fimAplicacao) : ''}
                onChange={(e) => {
                  const date = new Date(e.target.value);
                  this.setState({ fimAplicacao: date });
                }}
              />

              {this.state.talhoes.length > 0 && (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '1.5rem',
                    gridColumn: 'span 2',
                  }}
                >
                  {this.state.talhoes.map((talhao, index) => (
                    <React.Fragment key={index}>
                      <TextField
                        label={`${res.TALHAO} ${index + 1}`}
                        fullWidth
                        value={talhao.name || ''}
                        onChange={(e) => {
                          const talhoes = [...this.state.talhoes];
                          talhoes[index].name = e.target.value;
                          this.setState({ talhoes });
                        }}
                      />
                      <TextField
                        label={res.LATITUDE}
                        fullWidth
                        value={talhao.latitude || ''}
                        onChange={(e) => {
                          const talhoes = [...this.state.talhoes];
                          talhoes[index].latitude = e.target.value;
                          this.setState({ talhoes });
                        }}
                      />
                      <TextField
                        label={res.LONGITUDE}
                        fullWidth
                        value={talhao.longitude || ''}
                        onChange={(e) => {
                          const talhoes = [...this.state.talhoes];
                          talhoes[index].longitude = e.target.value;
                          this.setState({ talhoes });
                        }}
                      />
                    </React.Fragment>
                  ))}
                </div>
              )}
            </DialogContentText>
            {this.state.next !== "JSON" &&
              <DialogTitle id="customized-dialog-title">
                {res.MAPA}
              </DialogTitle>}
            <DialogContentText style={{ display: 'grid', gridTemplateColumns: '15rem 15rem' }}>
              {this.state.next !== "JSON" && <>
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkTrajetoria} name="checkTrajetoria" onClick={event => this.setState({ checkTrajetoria: !this.state.checkTrajetoria })} />} label={res.TRAJETORIA_VOO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkPoligono} name="checkPoligono" onClick={event => this.setState({ checkPoligono: !this.state.checkPoligono })} />} label={res.POLIGONO_APLICADO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkPoligonoLimpo} name="checkPoligonoLimpo" onClick={event => this.setState({ checkPoligonoLimpo: !this.state.checkPoligonoLimpo })} />} label={res.POLIGONO_NAO_APLICADO} />
              </>}
              {this.state.next === "KMZ" && <FormControlLabel control={<Switch color="primary" checked={this.state.checkXcl} name="checkXcl" onClick={event => this.setState({ checkXcl: !this.state.checkXcl })} />} label={res.ZONA_EXCLUSAO} />}
              {this.state.next === "APL" && <FormControlLabel control={<Switch color="primary" checked={this.state.checkMapa} name="checkMapa" onClick={event => this.setState({ checkMapa: !this.state.checkMapa })} />} label={res.MAPA_FUNDO} />}
              {this.state.next === "APL" && <FormControlLabel control={<Switch color="primary" checked={this.state.checkCoordenadas} name="checkCoordenadas" onClick={event => this.setState({ checkCoordenadas: !this.state.checkCoordenadas })} />} label={res.CAMADA_COORDENADAS} />}
            </DialogContentText>
            <DialogTitle id="customized-dialog-title">
              {res.TRABALHO}
            </DialogTitle>
            <DialogContentText style={{ display: 'grid', gridTemplateColumns: '15rem 15rem' }}>
              {this.state.next !== "JSON" && <>
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkVazao} name="checkVazao" onClick={event => this.setState({ checkVazao: !this.state.checkVazao })} />} label={res.VAZAO} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkVolume} name="checkVolume" onClick={event => this.setState({ checkVolume: !this.state.checkVolume })} />} label={res.VOLUME_APLICADO} />
              </>}
              {this.state.next === "KMZ" && <>
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkOnOff} name="checkOnOff" onClick={event => this.setState({ checkOnOff: !this.state.checkOnOff })} />} label={res.SPRAY_ON_OFF} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkRumo} name="checkRumo" onClick={event => this.setState({ checkRumo: !this.state.checkRumo })} />} label={res.RUMO_AB} />
                {this.state.showEstenderTiro && <FormControlLabel control={<Switch color="primary" checked={this.state.checkEstenderTiro} name="checkEstenderTiro" onClick={event => this.setState({ checkEstenderTiro: !this.state.checkEstenderTiro })} />} label={res.ESTENDER_TIRO} />}
              </>}
              <FormControlLabel control={<Switch color="primary" checked={this.state.checkAltura} name="checkAltura" onClick={event => this.setState({ checkAltura: !this.state.checkAltura })} />} label={res.ALTURA} />
              {this.state.next !== "JSON" && <>
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkCliente} name="checkCliente" onClick={event => this.setState({ checkCliente: !this.state.checkCliente })} />} label={res.NOME_CLIENTE} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkAeronave} name="checkAeronave" onClick={event => this.setState({ checkAeronave: !this.state.checkAeronave })} />} label={res.PREFIXO_AERONAVE} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkClima} name="checkClima" onClick={event => this.setState({ checkClima: !this.state.checkClima })} />} label={res.VARIAVEIS_CLIMA} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkVelocidade} name="checkVelocidade" onClick={event => this.setState({ checkVelocidade: !this.state.checkVelocidade })} />} label={res.VELOCIDADE} />
                <FormControlLabel control={<Switch color="primary" checked={this.state.checkFaixa} name="checkFaixa" onClick={event => this.setState({ checkFaixa: !this.state.checkFaixa })} />} label={res.FAIXA_APLICACAO} />
              </>}
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <Button disabled={this.state.disabledPorcessJob} id='prcessJob' component="span" variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton" title={res.PROCESSAR_JOB} onClick={this.runNext}>
              <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -4 24 24">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
              </svg>
            </Button>
            <Button
              variant="contained"
              onClick={event => this.setState({ open: false })}
            >
              {res.CANCELAR}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog onClose={event => this.setState({ openTask: false })} aria-labelledby="simple-dialog-title" open={this.state.openTask}>
          <DialogTitle id="simple-dialog-title">{res.PROCESSANDO}</DialogTitle>
          <List>
            {this.state.itensTask.map((task) => (
              <ListItem button onClick={(event) => task.progress === 100 && this.checkTask(task.id, true)} key={task.id}>
                <ListItemText primary={task.title} />
                <div style={{ height: '1rem', width: '2.5rem', textAlign: 'right', alignSelf: 'baseline', marginTop: '.3rem' }}>{task.progress + '%'}</div>
              </ListItem>
            ))}
          </List>
        </Dialog>
        <Dialog onClose={event => this.setState({ showPerc: false })} aria-labelledby="simple-dialog-title" open={this.state.showPerc}>
          <div style={{ width: '19rem', height: '10rem', textAlign: 'center' }}>
            <DialogTitle id="simple-dialog-title">{res.AJUSTE_EXIBICAO}</DialogTitle>
            <h3>{res.LARGURA_FAIXA}</h3>

            < Button className={"buttonS buttonMenu"} disabled={this.state.percSize <= 50} onClick={event => this.changeSize(-10)}>
              <SvgIcon viewBox="0 -960 960 960" className="iconMapP" style={{ color: this.state.percSize <= 50 ? '#b9b9b9' : 'black' }} >
                <path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm384-16v-80h320v80H600Z" />
              </SvgIcon>
            </Button>
            <label style={{ margin: '.2rem' }}>  {this.state.percSize}%  </label>
            < Button className={"buttonS buttonMenu"} disabled={this.state.percSize >= 150} onClick={event => this.changeSize(10)}>
              <SvgIcon viewBox="0 -960 960 960" className="iconMapP" style={{ color: this.state.percSize >= 150 ? '#b9b9b9' : 'black' }} >
                <path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm504 104v-120H600v-80h120v-120h80v120h120v80H800v120h-80Z" />
              </SvgIcon>
            </Button>
          </div>

          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <Button onClick={this.runPerc} color="primary">
              {res.PROCESSAR}
            </Button>
            <Button onClick={() => this.setState({ showPerc: false })} color="primary" autoFocus>
              {res.CANCELAR}
            </Button>
          </div>

        </Dialog>
        <Dialog
          open={this.state.clear}
          onClose={() => this.setState({ clear: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.state.new.msg}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => this.state.new.func()} color="primary">
              {res.SIM}
            </Button>
            <Button onClick={() => this.setState({ clear: false })} color="primary" autoFocus>
              {res.NAO}
            </Button>
          </DialogActions>
        </Dialog>
        <Backd style={{ zIndex: 1002, color: '#fff' }} open={this.state.progress}>
          {this.state.progressValue > 0 ?
            <CircularProgress style={{ scale: '2' }} variant="determinate" value={this.state.progressValue} color="inherit" disableShrink /> :
            <CircularProgress color="inherit" disableShrink />
          }
        </Backd>
        <div className='title-grid'>
          <div className="divContent padding-title">
            <div>
              <div><h1 className='title-align'>{res.RELATORIO}</h1></div>
              <div className={'zoomButton ' + classes.zoomButtonJobReport}>
                <input
                  accept=".zjob"
                  style={{ display: 'none' }}
                  id="contained-button-file"
                  type="file"
                  onChange={this.loadFile}
                />
                {this.state.serviceOrderID ? (
                  <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" style={{ marginRight: '.4rem' }}
                    onClick={this.handleBackToServiceOrder}
                    title={res.ORDEM_SERVICO}
                  >
                    <DescriptionIcon className="iconArrow" style={{ color: 'white', width: '2rem', height: '2rem' }} />
                  </Button>
                ) : null}

                <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" disabled={!this.state.guid} style={{ marginRight: '.4rem' }}
                  onClick={event => (this.props.link('/app/stats/' + (this.state.job_guid ? this.state.job_guid : this.props.guid)))} title={res.INSPECIONAR}>
                  <MaterialIcon icon="play_arrow" className="iconMap highlightSVG" />
                </Button>
                <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" disabled={!this.state.guid} style={{ marginRight: '.4rem' }}
                  onClick={event => (this.props.link('/app/kmz-map/' + (this.state.job_guid ? this.state.job_guid : this.props.guid)))} title={'KMZ'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -4 24 24">
                    <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z" />
                    M 0 14 L 0 16 L 16 16 L 16 14 Z M 0 0 L 0 2 L 16 2 L 16 0 Z M 0 4 L 0 12 L 16 12 L 16 4 Z
                  </svg>
                </Button>
                <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" disabled={!this.state.guid} style={{ marginRight: '.4rem' }}
                  onClick={event => (this.openModal("KMZ"))} title={'KMZ / SHAPE'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 541 541">
                    <path class="fil0" d="M419.32 190.36l0 159.3 -24.51 0 0 -159.3 -49.01 0c-20.31,0 -36.77,-16.46 -36.77,-36.76l0 -49.02 -134.79 0c-13.53,0 -24.5,10.97 -24.5,24.51l0 220.57 -24.52 0 0 -220.57c0.01,-27.07 21.96,-49.02 49.03,-49.02l134.78 0 110.29 110.29z" />
                    <path class="fil1" d="M144.72 462.41l0 -89.86 18.54 0 0 39.81 37.35 -39.81 24.82 0 -34.52 35 36.32 54.86 -23.9 0 -25.19 -42.19 -14.88 15.02 0 27.17 -18.54 0zm91.8 0l0 -89.86 27.76 0 16.4 61.28 16.21 -61.28 27.82 0 0 89.86 -17.12 0 -0.07 -70.74 -18.04 70.74 -17.81 0 -17.96 -70.74 -0.07 70.74 -17.12 0zm98.68 0l0 -16.32 48.22 -58.35 -42.73 0 0 -15.19 66.98 0 0 14.06 -50.11 60.61 52.02 0 0 15.19 -74.38 0z" />
                    <path class="fil0" d="M283.54 229.95c0,-6.23 -5.05,-11.28 -11.28,-11.28 -6.23,0 -11.28,5.05 -11.28,11.28l0 85.62 -25.88 -25.89c-2.1,-2.12 -4.99,-3.32 -7.98,-3.32 -6.25,0 -11.31,5.06 -11.31,11.31 0,2.99 1.2,5.87 3.31,7.99l45.15 45.15c2.12,2.11 5,3.31 7.99,3.31 2.99,0 5.87,-1.2 7.99,-3.32l45.15 -45.15c2.11,-2.11 3.31,-4.99 3.31,-7.98 0,-6.25 -5.06,-11.31 -11.31,-11.31 -2.99,0 -5.88,1.2 -7.99,3.31l-25.87 25.9 0 -85.62z" />
                  </svg>
                </Button>
                <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" disabled={!this.state.guid} style={{ marginRight: '.4rem' }}
                  onClick={event => (this.openModal("JSON"))} title={'JSON'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -4 24 24">
                    <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
                    <path fill-rule="evenodd" d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM4.151 15.29a1.176 1.176 0 0 1-.111-.449h.764a.578.578 0 0 0 .255.384c.07.049.154.087.25.114.095.028.201.041.319.041.164 0 .301-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .084-.29.387.387 0 0 0-.152-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.352-.367 1.068 1.068 0 0 1-.123-.524c0-.244.064-.457.19-.639.128-.181.304-.322.528-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.185.384c0 .121.048.22.144.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-3.104-.033a1.32 1.32 0 0 1-.082-.466h.764a.576.576 0 0 0 .074.27.499.499 0 0 0 .454.246c.19 0 .33-.055.422-.164.091-.11.137-.265.137-.466v-2.745h.791v2.725c0 .44-.119.774-.357 1.005-.237.23-.565.345-.985.345a1.59 1.59 0 0 1-.568-.094 1.145 1.145 0 0 1-.407-.266 1.14 1.14 0 0 1-.243-.39Zm9.091-1.585v.522c0 .256-.039.47-.117.641a.862.862 0 0 1-.322.387.877.877 0 0 1-.47.126.883.883 0 0 1-.47-.126.87.87 0 0 1-.32-.387 1.55 1.55 0 0 1-.117-.641v-.522c0-.258.039-.471.117-.641a.87.87 0 0 1 .32-.387.868.868 0 0 1 .47-.129c.177 0 .333.043.47.129a.862.862 0 0 1 .322.387c.078.17.117.383.117.641Zm.803.519v-.513c0-.377-.069-.701-.205-.973a1.46 1.46 0 0 0-.59-.63c-.253-.146-.559-.22-.916-.22-.356 0-.662.074-.92.22a1.441 1.441 0 0 0-.589.628c-.137.271-.205.596-.205.975v.513c0 .375.068.699.205.973.137.271.333.48.589.626.258.145.564.217.92.217.357 0 .663-.072.917-.217.256-.146.452-.355.589-.626.136-.274.205-.598.205-.973Zm1.29-.935v2.675h-.746v-3.999h.662l1.752 2.66h.032v-2.66h.75v4h-.656l-1.761-2.676h-.032Z" />
                  </svg>
                </Button>
                <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" disabled={!this.state.guid} style={{ marginRight: '.4rem' }}
                  onClick={event => (this.openModal("APL"))} title={res.RELATORIO_APLICACAO}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -4 24 24">
                    <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                  </svg>
                </Button>
                <Button variant="contained" className={'popUpButton ' + classes.popUpButtonJobReport} color="primary" disabled={!this.state.guid} style={{ marginRight: '.4rem' }}
                  onClick={() => { this.setState({ showPerc: true }) }} title={res.AJUSTAR_EXIBICAO}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -4 24 24">
                    <path d="M 0 13 L 0 14 L 16 14 L 16 13 Z M 0 2 L 0 3 L 16 3 L 16 2 Z M 0 5 L 0 11 L 16 11 L 16 5 Z" />
                  </svg>
                </Button>
                <Button variant="contained" color="primary" disabled={this.state.itensTask.length === 0} className="popUpButton" style={{ marginRight: '.4rem' }}
                  onClick={event => this.loadTask(true)} title={res.EXIBIR_RELATORIO}>
                  <MaterialIcon icon="settings" className="iconMap highlightSVG" />
                </Button>
              </div>
            </div>
          </div>
          <div id="divFloat" className="div-list_p divContentList list-p">
            <div style={{ padding: '1rem' }}>
              <div>
                <h2 title={this.state.title}>{this.state.title.length > 25 ? this.state.title.substring(0, 25) + '...' : this.state.title}</h2>
              </div>
              {this.state.title !== this.state.title_sk &&
                <div style={{ textAlign: 'right', marginTop: '-1rem' }}>
                  <h4 style={{ color: '#bcbcbc' }}>{this.state.title_sk}</h4>
                </div>
              }
            </div>
            <div className="div-list_h">
              <div className="div-list_box">
                <div style={{ width: '100%', textAlign: 'center', marginTop: '1rem', marginBottom: '-1rem' }}><h3>{res.INFORMACAO}</h3></div>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.item_title(res.CLIENTE)}
                    {this.item_value(this.state.customerNameT ? this.state.customerNameT : '-')}
                    {this.item_title(res.AERONAVE)}
                    {this.item_value(this.state.aeronavePrefixT ? this.state.aeronavePrefixT : '-')}
                    {/*
                      {this.item_title(res.PILOTO)}
                      {this.item_value("-")}
                      */}
                  </TableBody>
                </Table>
                <div style={{ width: '100%', textAlign: 'center', marginTop: '1rem', marginBottom: '-1.5rem' }}><h3>{res.ANALISE_TEMPO}</h3></div>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">{res.REALIZADO}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.item_title(res.TEMPO_TOTAL)}
                    {this.item_value(
                      tools.fancyTimeFormat(isNaN(this.state.time) ? this.state.tTotal_exe : this.state.tTotal_exe + this.state.time) +
                      ((!isNaN(this.state.time) && Number(this.state.time) !== 0) ? ' *' : ''))}
                    {this.item_title(res.TEMPO_SOLO)}
                    {this.item_value(
                      tools.fancyTimeFormat(this.state.tSolo_exe),
                      this.state.tSolo_exe,
                      isNaN(this.state.time) ? this.state.tTotal_exe : this.state.tTotal_exe + this.state.time)}
                    {this.item_title(res.TEMPO_TRANSLADO)}
                    {this.item_value(
                      tools.fancyTimeFormat(isNaN(this.state.time) ? this.state.tTran_exe : this.state.tTran_exe + this.state.time) +
                      ((!isNaN(this.state.time) && Number(this.state.time) !== 0) ? ' *' : ''),
                      isNaN(this.state.time) ? this.state.tTran_exe : this.state.tTran_exe + this.state.time,
                      isNaN(this.state.time) ? this.state.tTotal_exe : this.state.tTotal_exe + this.state.time)}
                    {this.item_title(res.TEMPO_BALAO)}
                    {this.item_value(
                      tools.fancyTimeFormat(this.state.tLoop_exe),
                      this.state.tLoop_exe,
                      isNaN(this.state.time) ? this.state.tTotal_exe : this.state.tTotal_exe + this.state.time)}
                    {this.item_title(res.TEMPO_APLICACAO)}
                    {this.item_value(
                      tools.fancyTimeFormat(this.state.tApl_exe),
                      this.state.tApl_exe,
                      isNaN(this.state.time) ? this.state.tTotal_exe : this.state.tTotal_exe + this.state.time)}
                  </TableBody>
                </Table>
                {this.state.difficulty >= 0 ?
                  <div style={{ width: '100%', marginTop: '1rem' }}>
                    <div style={{ marginLeft: '1.5rem', marginRight: '0.5rem' }}>
                      <Slider res={res} value={this.state.difficulty ? this.state.difficulty : 0} />
                    </div>
                  </div> :
                  <div style={{ width: '100%', marginTop: '1rem' }}></div>
                }
                <div style={{ width: '100%', textAlign: 'center', marginTop: '1rem', marginBottom: '-1.5rem' }}><h3>{res.ANALISE_GERAL}</h3></div>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell align="right">{res.REALIZADO}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.item_title(tools.replaceString(res._RENDIMENTO, Units.getAreaRateUnit(res)))}
                    {this.item_value(
                      (this.state.rend_exe ? Units.formatValue(Units.convertAreaRate(this.state.rend_exe, 'ha', res), res) : Units.formatValue(0, res)))}

                    {this.item_title(res.TOTAL_DIAS)}
                    {this.item_value(
                      (this.state.dias_exe && this.state.dias_exe.length > 0 ?
                        (this.state.dias_exe.length > 1 ?
                          this.state.dias_exe.length + ' ' + res.DIAS : this.state.dias_exe.length + ' ' + res.DIA)
                        : 0))}

                    {this.item_title(res.DATA_EXECUCAO)}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="right">
                        {this.state.dtIni
                          ? tools.dateTimeZoneFormat(this.state.dtIni, this.props.res.FORMAT_DATAHORAMIN, this.props.res.timezone)
                          : '-'}
                      </TableCell>
                      <TableCell align="right">
                        {this.state.dtFim
                          ? tools.dateTimeZoneFormat(this.state.dtFim, this.props.res.FORMAT_DATAHORAMIN, this.props.res.timezone)
                          : '-'}
                      </TableCell>
                    </TableRow>
                    {this.item_title(Units.getAreaUnit(res) === 'ac' ? res.TOTAL_ACRE : res.TOTAL_HECTARE)}
                    {this.item_value(
                      (!isNaN(this.state.area_exe) ? Units.formatValue(Units.convertArea(this.state.area_exe, 'ha', res), res, 1) : this.state.area_exe))}

                    {this.item_title(tools.replaceString(res._COMSUMO_TOTAL, Units.getVolumeUnit(res)))}
                    {this.item_value(Units.formatValue(Units.convertVolume(this.state.totalApl_exe, 'L', res), res))}

                    {this.item_title(tools.replaceString(res._FLUXO_MEDIO, Units.getFlowUnit(res)))}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="right">
                        {this.state.sprSet
                          ? Units.formatValue(Units.convertFlow(this.state.sprSet, 'L', 'ha', res), res)
                          : '-'}
                      </TableCell>
                      <TableCell align="right">
                        {this.state.sprApl_exe
                          ? Units.formatValue(Units.convertFlow(this.state.sprApl_exe, 'L', 'ha', res), res)
                          : '-'}
                      </TableCell>
                    </TableRow>

                    {this.item_title(res.REABASTECIMENTO)}
                    {this.item_value(
                      this.state.qtdFuel_exe)}

                    {this.item_title(tools.replaceString(res._LARGURA_FAIXA, Units.getLengthUnit(res)))}
                    {this.item_value(Units.formatValue(Units.convertLength(this.state.swathwidth_exe, 'm', res), res))}

                    {this.item_title(tools.replaceString(res._ALTURA_MEDIA, Units.getLengthUnit(res)))}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="right">
                        {this.state.altSet
                          ? Units.formatValue(Units.convertLength(this.state.altSet, 'm', res), res)
                          : '-'}
                      </TableCell>
                      <TableCell align="right">
                        {this.state.altApl_exe
                          ? Units.formatValue(Units.convertLength(this.state.altApl_exe, 'm', res), res)
                          : '-'}
                      </TableCell>
                    </TableRow>

                    {this.item_title(tools.replaceString(res._VELOCIDADE_MEDIA, Units.getSpeedUnit(res)))}
                    {this.item_value(Units.formatValue(Units.convertSpeed(this.state.velAverage, 'km/h', res), res))}

                    {this.item_title(tools.replaceString(res._VELOCIDADE_APLICACAO, Units.getSpeedUnit(res)))}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell align="right">
                        {this.state.velSet
                          ? Units.formatValue(Units.convertSpeed(this.state.velSet, 'km/h', res), res)
                          : '-'}
                      </TableCell>
                      <TableCell align="right">
                        {this.state.velApl_exe
                          ? Units.formatValue(Units.convertSpeed(this.state.velApl_exe, 'km/h', res), res)
                          : '-'}
                      </TableCell>
                    </TableRow>

                    {this.item_title(tools.replaceString(res._VELOCIDADE_TRANSLADO, Units.getSpeedUnit(res)))}
                    {this.item_value(Units.formatValue(Units.convertSpeed(this.state.velTrans_exe, 'km/h', res), res))}

                    {this.item_title(tools.replaceString(res._VELOCIDADE_MEDIA_BALAO, Units.getSpeedUnit(res)))}
                    {this.item_value(Units.formatValue(Units.convertSpeed(this.state.velLoop_exe, 'km/h', res), res))}
                  </TableBody>
                </Table>
                <div style={{ width: '100%', textAlign: 'center', marginTop: '1rem', marginBottom: '-1.5rem' }}>
                  <h3>{res.ANALISE_CLIMA}</h3>
                </div>
                <Table size="small" aria-label="a dense table" className={this.props.classes.climateTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: '2%', padding: '4px' }}>
                        {<Button
                            onClick={this.toggleWindSpeedUnit}
                            variant="contained"
                            title={this.state.windSpeedUnit === 'm/s' ? res.VELOCIDADE_VENTO_MS : Units.getSpeedUnit(res).toUpperCase()}
                            style={{ backgroundColor: 'rgb(250, 125, 52)', color: 'white', fontSize: '0.75rem', minWidth: '60px', padding: '4px 8px' }}
                          >
                            {this.state.windSpeedUnit === 'm/s' ? 'M/S' : Units.getSpeedUnit(res).toUpperCase()}
                            <SpeedIcon style={{ marginLeft: '0.25rem', fontSize: '1rem' }} />
                          </Button>
                        }
                      </TableCell>
                      <TableCell style={{ width: '48%' }}></TableCell>
                      <TableCell style={{ width: '48%' }} align="right">{res.REALIZADO}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(this.state.weatherData || [])
                      .filter((data, index, array) =>
                        !data ||
                        !data.guid ||
                        !array.slice(index + 1).some(item => item && item.guid === data.guid)
                      )
                      .slice()
                      .sort((a, b) => {
                        const dateA = a.startData?.[0]?.startDate || '';
                        const dateB = b.startData?.[0]?.startDate || '';
                        return new Date(dateA) - new Date(dateB);
                      })
                      .map((data, index) => (
                        <React.Fragment key={data.guid || index}>
                          {this.renderClimateData(data.guid, data.lat, data.lng)}
                        </React.Fragment>
                      ))}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <div className="divContent divRelative map-p">
          <div className="containerTop">
            <div className="leftTop">
              <Button className="buttonS buttonMenu buttonMenuSmall" onClick={event => this.showMenu()}>
                <MaterialIcon icon="menu" className="iconMapF" />
              </Button>
              <Button className={this.state.ruler_a ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={event => this.regua()}>
                <MaterialIcon icon="settings_ethernet" className="iconMap highlightSVG" />
              </Button>
            </div>
            <div className="centerTop"></div>
            <div className="rightTop">
              <Button
                className="buttonS buttonMenu"
                onClick={this.toggleCoordMode}
                title={(this.state.coordMode) === 'dms' ? res.COORDENADA_DMS : res.COORDENADA_DD}
              >
                <MaterialIcon icon="swap_horiz" className="iconMap" />
              </Button>
              <label htmlFor="contained-button-file" style={{ marginBottom: 0, display: 'inline' }}>
                <Button className="buttonS buttonMenu" onClick={event => this.setState({ stack: !this.state.stack })}>
                  <MaterialIcon icon="layers" className="iconMap" />
                </Button>
              </label>
            </div>
          </div>

          <div className="wrapperMap">
            <div id="mapid"></div>
            <div className="zoomB">
              <Button className="buttonS buttonMenu" onClick={event => this.zoomInL()}>
                <MaterialIcon icon="add" className="iconMap" />
              </Button>
              <Button className="buttonS buttonMenu" onClick={event => this.zoomOutL()}>
                <MaterialIcon icon="remove" className="iconMap" />
              </Button>
            </div>

            <div className={this.state.addKm ? "divContent floatDiv floatDivItens popUpF" : "sr-only"}>
              <div style={{ overflowY: 'auto' }}>
                <div>
                  <TextField
                    id="list_name"
                    label={res.ADD_TRANSLADO}
                    margin="none"
                    className="textI"
                    size="small"
                    style={{ width: '12rem' }}
                    value={this.state.valor}
                    onChange={this.handleChange("valor")}
                    onKeyDown={e => {
                      if (e.keyCode === 13) { this.addKm() }
                    }}
                    type="number"
                    onInput={(e) => {
                      e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                    }}
                  />
                </div>
              </div>
              <div className="divForm">
                <Button size="small" className="popUpButton" style={{ marginRight: '1rem' }} onClick={event => this.addKm()}>
                  {res.ADICIONAR}
                </Button>
                <Button size="small" className="popUpButton" onClick={event => this.setState({ addKm: !this.state.addKm })}>
                  {res.CANCELAR}
                </Button>
              </div>
            </div>

            {this.state.stack &&
              <div className="divContent floatW divS" onfocusout={event => this.setState({ stack: false })}>
                <List
                  component="nav"
                  aria-labelledby="stack"
                >
                  <ListItem key={3} button
                    className={(this.state.stack_value[2] === 1) ? 'SelItem' : ''}
                    onClick={event => this.handleStackClick(3)}
                  >
                    <ListItemText id={3} primary={res.AREA} />
                  </ListItem>

                  <ListItem key={2} button
                    className={(this.state.stack_value[1] === 1) ? 'SelItem' : ''}
                    onClick={event => this.handleStackClick(2)}
                  >
                    <ListItemText id={2} primary={res.CAMINHO} />
                  </ListItem>

                  <ListItem key={1} button
                    className={(this.state.stack_value[0] === 1) ? 'SelItem' : ''}
                    onClick={event => this.handleStackClick(1)}
                  >
                    <ListItemText id={1} primary={res.APLICACAO} />
                  </ListItem>
                  <ListItem key={4} button
                    className={(this.state.stack_value[3] === 1) ? 'SelItem' : ''}
                    onClick={event => this.handleStackClick(4)}
                  >
                    <ListItemText id={1} primary={res.TITULO} />
                  </ListItem>
                  <ListItem key={5} button
                    className={(this.state.stack_value[4] === 1) ? 'SelItem' : ''}
                    onClick={event => this.handleStackClick(5)}
                    disabled={
                      !(
                        this.state.weatherData[0]?.startData?.length > 0 &&
                        this.state.weatherData[0]?.endData?.length > 0
                      )
                    }
                  >
                    <ListItemText id={5} primary={res.ESTACAO} />
                  </ListItem>
                </List>
              </div>}
          </div>
        </div>
      </div >
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { guid } = useParams();
  return (
    <div className="rowPMap maxHMap">
      <TextFields1 link={link} guid={guid} res={res} />
    </div>)
}
export default Box;
